<template>
  <v-container grid-list-md class="py-0 px-2 ma-0">
    <v-row>
      <v-col cols="12" class="pt-0">
        <v-card flat v-if="lAction === 'view'">
          <v-card-title class="px-0">
            <v-layout row wrap>
              <v-flex xs10>
                <v-text-field
                class="pa-0 mt-1"
                append-icon="mdi-account-search-outline"
                :placeholder="$vuetify.breakpoint.smAndUp?'Search Project Name':'Search'"
                single-line
                hide-details
                v-model="search"
                @input="searchProjectTitle(search)"
                outlined
                clearable
                ></v-text-field>
              </v-flex>
              <v-flex xs2 class="text-right pt-4">
                <v-chip :class="isClosedProject ? 'info dark' : '' " @click="showClosedProjects()">Show Closed Projects</v-chip>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text class="px-0">
            <v-flex xs12>
              <v-card>
                <v-expansion-panels :value="selTab">
                  <v-expansion-panel v-for="(proj_name, i) in deboardReviewProjList" :key="i">
                    <v-expansion-panel-header style="min-height: 40px;" class="py-0 grey lighten-3">
                      <div class="subtitle-2">{{proj_name}}</div>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content class="pt-3">
                      <v-data-table
                      :headers="deboardReviewSummaryListHeader"
                      :items="lDeboardReviewSummaryList.filter(rec => rec.proj_name === proj_name)"
                      hide-default-footer
                      dense
                      disable-pagination
                      :mobile-breakpoint="0"
                      class="elevation-1">
                        <template slot="item" slot-scope="props">
                          <tr @click="prepareUpdate(props.item)" :class="props.item.proj_status === 'Closed' ? 'grey--text' : ''">
                            <td style="font-size: 12px;">{{ props.index + 1 }}</td>
                            <td style="font-size: 12px;">{{ props.item.current_dept }}</td>
                            <td style="font-size: 12px;">{{ props.item.version_no }}</td>
                            <td style="font-size: 12px;">{{ props.item.project_contract_version ? props.item.project_contract_version : '-' }}</td>
                            <td style="font-size: 12px;">{{ props.item.contract_amt_with_tax ? handy.formatCur(props.item.contract_amt_with_tax) : '-' }}</td>
                          </tr>
                        </template>
                      </v-data-table>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-card>
            </v-flex>
          </v-card-text>
        </v-card>

        <v-btn :style="'position:fixed; ' + ($vuetify.breakpoint.smAndDown?'bottom:20px; right:15px;':'bottom:15px; right:15px;')"
        dark fab fixed color="accent" v-if="lAction === 'view' && config.IS_EDITED_BY_USER"
        @click.native="prepareCreate"><v-icon>mdi-playlist-plus</v-icon></v-btn>

        <!-- 1. create, update of Deboarding Review -->
        <v-container v-if="lAction === 'create' || lAction === 'update'" class="pa-0" fluid full-height>
          <v-layout row wrap>
            <v-flex xs12 class="mt-2">
              <v-form ref="pForm" @submit.prevent="saveDeboardReviewBaseChanges(lAction)">
                <v-card>
                  <v-card-title class="py-2 grey lighten-3">
                    <v-btn small icon @click="lAction = 'view'"><v-icon>mdi-arrow-left</v-icon></v-btn>
                    <span style="font-size: 17px" class="font-weight-bold pl-2 primary--text">{{ handy.startWithUpper(lAction) + ' Deboarding Review' }}</span>
                  </v-card-title>
                  <v-card-text class="pb-0 pt-2">
                    <v-layout>
                      <v-flex xs12>
                        <v-layout row wrap>
                          <v-flex xs3>
                            <v-combobox
                            v-model="lDeboardReviewBase.comm_pair"
                            :items="commList"
                            item-text="comm_name"
                            item-value="comm_id"
                            label="Community"
                            hide-details
                            dense
                            outlined
                            style="font-size: 12px"
                            color="primary"
                            :disabled="lAction === 'update'"
                            :rules="[rules.required]"
                            ></v-combobox>
                          </v-flex>
                          <v-flex xs1 style="flex-basis: 0%" class="pt-3">
                            <v-btn small icon :disabled="!lDeboardReviewBase.comm_pair.comm_id" @click="showBasicInformationOfCommunity(lDeboardReviewBase)"><v-icon>mdi-information-outline</v-icon></v-btn>
                          </v-flex>
                          <v-flex xs3>
                            <v-combobox
                            v-model="lDeboardReviewBase.proj_pair"
                            :items="projList"
                            item-text="proj_name"
                            item-value="proj_id"
                            label="Project"
                            hide-details
                            dense
                            outlined
                            style="font-size: 12px"
                            color="primary"
                            clear-icon="mdi-close-circle-outline"
                            :disabled="lAction === 'update'"
                            ></v-combobox>
                          </v-flex>
                          <v-flex xs1 style="flex-basis: 0%" class="pt-3">
                            <v-btn small icon :disabled="!lDeboardReviewBase.proj_pair.proj_id" @click="showBasicInformationOfProject(lDeboardReviewBase)"><v-icon>mdi-information-outline</v-icon></v-btn>
                          </v-flex>
                          <v-flex xs3>
                            <v-autocomplete
                            v-model="lDeboardReviewBase.proj_contract_base_id"
                            :items="projContractList"
                            item-text="contract_version"
                            item-value="proj_contract_base_id"
                            label="Project Contract Ver"
                            hide-details
                            dense
                            outlined
                            clear-icon="mdi-close-circle-outline"
                            style="font-size: 12px"
                            color="primary"
                            :disabled="lAction === 'update'"
                            ></v-autocomplete>
                          </v-flex>
                          <v-flex xs1 style="flex-basis: 0%" class="pt-3">
                            <v-btn small icon :disabled="!lDeboardReviewBase.proj_contract_base_id" @click="showBasicInformationOfProjectContract(lDeboardReviewBase)"><v-icon>mdi-information-outline</v-icon></v-btn>
                          </v-flex>
                          <v-flex xs3>
                            <v-dialog ref="dlgDate"
                            persistent v-model="dlgDate"
                            max-width="290px"
                            :return-value.sync="lDeboardReviewBase.on_boarding_date">
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                slot="activator" label="On-boarding Date"
                                v-model="lDeboardReviewBase.on_boarding_date" append-icon="mdi-calendar-today"
                                readonly
                                v-on="on"
                                hide-details
                                outlined
                                dense
                                :disabled="disableSubmitButton || lAction === 'update'"
                                color="primary"
                                style="font-size: 12px"
                                ></v-text-field>
                              </template>
                              <v-date-picker v-model="lDeboardReviewBase.on_boarding_date"
                              :disabled="disableSubmitButton || lAction === 'update'"
                              first-day-of-week="1">
                                <v-spacer></v-spacer>
                                <v-btn text @click="dlgDate = false">Cancel</v-btn>
                                <v-btn text color="accent" @click="$refs.dlgDate.save(lDeboardReviewBase.on_boarding_date)">OK</v-btn>
                              </v-date-picker>
                            </v-dialog>
                          </v-flex>
                          <v-flex xs1 style="flex-basis: 3%">
                          </v-flex>
                          <v-flex xs3 class="ml-2">
                            <v-autocomplete
                            v-model="lVersion"
                            label="Sales Review Version"
                            :items="versionList"
                            item-text="version"
                            item-value="mi_base_id"
                            hide-details
                            outlined
                            style="font-size: 12px"
                            dense
                            color="primary"
                            :disabled="disableSubmitButton || lAction === 'update'"
                            >
                            </v-autocomplete>
                          </v-flex>
                          <v-flex xs1 style="flex-basis: 3%">
                          </v-flex>
                          <v-flex xs3 class="ml-2">
                            <v-dialog ref="dlgExitDate"
                            persistent v-model="dlgExitDate"
                            max-width="290px"
                            :return-value.sync="lDeboardReviewBase.proj_exit_date">
                              <template v-slot:activator="{ on }">
                                <v-text-field
                                slot="activator" label="Exit Date"
                                v-model="lDeboardReviewBase.proj_exit_date" append-icon="mdi-calendar-today"
                                readonly
                                v-on="on"
                                hide-details
                                outlined
                                dense
                                :disabled="disableSubmitButton"
                                color="primary"
                                style="font-size: 12px"
                                ></v-text-field>
                              </template>
                              <v-date-picker v-model="lDeboardReviewBase.proj_exit_date"
                              :disabled="disableSubmitButton"
                              first-day-of-week="1">
                                <v-spacer></v-spacer>
                                <v-btn text @click="dlgExitDate = false">Cancel</v-btn>
                                <v-btn text color="accent" @click="$refs.dlgExitDate.save(lDeboardReviewBase.proj_exit_date)">OK</v-btn>
                              </v-date-picker>
                            </v-dialog>
                          </v-flex>
                          <v-flex xs11>
                            <v-textarea
                            v-model="lDeboardReviewBase.deboard_remarks"
                            label="Reason for Contract Closure"
                            hide-details
                            outlined
                            maxlength="1000"
                            style="font-size: 12px;"
                            :rules="[rules.required]"
                            ></v-textarea>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                      <v-flex xs1>
                        <v-layout>
                          <v-flex xs3 style="flex-basis: 0%" class="pt-3">
                            <v-btn small :disabled="disableSubmitButton || showContractImportSection" style="width: 100px; margin-left: -40px" class="mt-2 accent" v-if="config.IS_EDITED_BY_USER" type="submit">save</v-btn>
                            <v-btn small :disabled="showContractImportSection" style="width: 100px; margin-left: -40px" class="mt-2 success white--text" @click="validateDeboardReview()">Validate</v-btn>
                            <v-btn small :disabled="showContractImportSection" style="width: 100px; margin-left: -40px" class="mt-2 uniformchipinfo white--text" @click="prepareDeboardingReviewView()">view</v-btn>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <v-flex xs12>
                      <v-layout row wrap class="pt-3 pa-0" v-if="showContractImportSection && this.lDeboardReviewBase.current_dept != 'Closed'">
                        <v-flex xs12>
                          <v-alert class="warning">
                            <v-layout v-if="this.lDeboardReviewBase.current_dept === 'Sales'" row wrap class="pa-0">
                              <v-flex xs12>
                                <div class="white--text font-weight-bold" style="font-size: 15px;">New Approved Contract {{ this.lDeboardReviewBase.new_proj_contract_version_no }} is avaiable for project "<strong><u>{{ lDeboardReviewBase.proj_pair.proj_name }}</u></strong>". Please change the Project Contract version and save in <strong><u>Sales Review</u></strong> to add new approved contract details. </div>
                              </v-flex>
                            </v-layout>
                            <v-layout v-if="this.lDeboardReviewBase.current_dept != 'Sales'" row wrap class="pa-0">
                              <v-flex xs12>
                                <div class="white--text font-weight-bold" style="font-size: 15px;">New Approved Contract {{ this.lDeboardReviewBase.new_proj_contract_version_no }} is avaiable for project "<strong><u>{{ lDeboardReviewBase.proj_pair.proj_name }}</u></strong>". Click import from <strong><u>{{ this.lDeboardReviewBase.current_dept }} Review</u></strong> to add new approved contract details. </div>
                              </v-flex>
                            </v-layout>
                          </v-alert>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-card-text>
                  <v-card-actions>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-flex>
            <v-flex xs12>
              <v-card>
                <v-card-text>
                  <v-expansion-panels multiple v-model="panel">
                    <!-- Deboarding Planner Details Expansion Panel -->
                    <v-expansion-panel>
                      <v-expansion-panel-header style="min-height: 40px;" class="py-0 grey lighten-3">
                        <div class="subtitle font-weight-bold">Deboarding Planner Details</div>
                        <v-flex xs8 class="text-right" v-if="config.IS_EDITED_BY_USER">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-chip small :class="isShowOnlyPendingItems ? 'info dark font-weight-bold' : 'grey darken-1 white--text font-weight-bold' " onclick="event.stopPropagation()" @click="loadOnlyPendingItems()">Show Only Pending Items</v-chip>
                              <v-btn v-on="on" class="ml-4 warning--text" icon small onclick="event.stopPropagation()" :disabled="disableSubmitButton || showContractImportSection" @click="prepareCreateDeboardingPlanner()"><v-icon>mdi-playlist-plus</v-icon></v-btn>
                            </template>
                            <span>Add New</span>
                          </v-tooltip>
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn v-on="on" class="ml-4 warning--text" icon small onclick="event.stopPropagation()" :disabled="disableSubmitButton || showContractImportSection" @click="prepareDeboardingPlannerImport(deboardPlannerReviewItemList)"><v-icon>mdi-table-arrow-down</v-icon></v-btn>
                            </template>
                            <span>Import</span>
                          </v-tooltip>
                        </v-flex>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content class="mt-2">
                        <v-expansion-panels :value="selTab">
                          <v-expansion-panel v-for="(cat, i) in deboardCat" :key="i">
                            <v-expansion-panel-header style="min-height: 40px;" class="py-1 grey lighten-3">
                              <div class="font-weight-bold primary--text body-2">
                                {{cat}}
                              </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content style="margin-left: -15px; margin-right: -15px" class="mt-2">
                              <v-data-table
                              :headers="deboardPlannerReviewItemHeader"
                              :items="deboardPlannerReviewItemList.filter(rec => rec.deb_planner_cat === cat)"
                              hide-default-footer
                              disable-pagination
                              dense
                              :mobile-breakpoint="0">
                                <template slot="item" slot-scope="props">
                                  <tr :class="(props.item.deb_status === 'Completed' || props.item.deb_status === 'Cancelled' || props.item.deb_status === 'Not Applicable') ? '' : 'red--text'" @click="disableSubmitButton || showContractImportSection || props.item.deb_source != source_var ? '' : prepareDebPlannerUpdate(props.item)">
                                    <td style="font-size: 12px;">{{ props.index + 1 }}</td>
                                    <td style="font-size: 12px;">{{ props.item.deb_planner_sub_cat }}</td>
                                    <td style="font-size: 12px;">{{ props.item.disp_short_name ? props.item.disp_short_name.replace(/,/g, ", ") : '-' }}</td>
                                    <td style="font-size: 12px;" class="text-center">{{ props.item.deb_plan_end_dt ? handy.formatDate(props.item.deb_plan_end_dt) : '-' }}</td>
                                    <td style="font-size: 12px;" class="text-center">{{ props.item.deb_actual_end_dt ? handy.formatDate(props.item.deb_actual_end_dt) : '-' }}</td>
                                    <td style="font-size: 12px;">{{ props.item.deb_status }}</td>
                                    <td style="font-size: 12px;">{{ props.item.deb_remarks ? props.item.deb_remarks : '-' }}</td>
                                  </tr>
                                </template>
                              </v-data-table>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <!-- Asset Deployed and recovered during exit Expansion Panel -->
                    <v-expansion-panel>
                      <v-expansion-panel-header style="min-height: 40px;" class="py-0 grey lighten-3">
                        <div class="subtitle font-weight-bold">Asset Recovery Details</div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content class="mt-2 px-0">
                        <v-data-table
                        :headers="onbPlannerRecoverAssetItemHeader"
                        :items="onbPlannerRecoverAssetItemList"
                        hide-default-footer
                        disable-pagination
                        dense
                        :mobile-breakpoint="0">
                        <template slot="item" slot-scope="props">
                          <!-- disable edit option if the source is "Sales" or disable submit variable is true -->
                          <tr :class="(props.item.mi_is_asset_recovered === 'No') ? 'red--text' : ''" @click="(disableSubmitButton || showContractImportSection) ? '' : prepareOnbPlannerAssetRecoveryUpdate(props.item)">
                            <td style="font-size: 12px;">{{ props.index + 1 }}</td>
                            <td style="font-size: 12px;">{{ props.item.onb_planner_cat }}</td>
                            <td style="font-size: 12px;">{{ props.item.onb_planner_sub_cat }}</td>
                            <td style="font-size: 12px;" class="text-center">{{ props.item.mi_is_asset_recoverable ? 'Yes' : 'No' }}</td>
                            <td style="font-size: 12px;" class="text-center">{{ props.item.mi_is_asset_recovered }}</td>
                            <td style="font-size: 12px;" class="text-center">{{ props.item.mi_asset_recovered_dt ? handy.formatDate(props.item.mi_asset_recovered_dt) : '-' }}</td>
                            <td style="font-size: 12px;">{{ props.item.mi_asset_rec_remarks ? props.item.mi_asset_rec_remarks : '-' }}</td>
                          </tr>
                        </template>
                        </v-data-table>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <!-- Outsourced manpower and service withdrown detail update Expansion Panel -->
                    <v-expansion-panel>
                      <v-expansion-panel-header style="min-height: 40px;" class="py-0 grey lighten-3">
                        <div class="subtitle font-weight-bold">Outsourced Manpower and Other Services Withdrawal Details</div>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content class="mt-2 px-0">
                        <v-data-table
                        :headers="manpowerandServiceWithdrawalItemHeader"
                        :items="manpowerandServiceWithdrawalItemList"
                        hide-default-footer
                        disable-pagination
                        dense
                        :mobile-breakpoint="0">
                        <template slot="item" slot-scope="props">
                          <tr :class="(props.item.deb_status === 'Not Yet' || props.item.deb_status === 'In-Progress' || props.item.deb_status === 'On-Hold') ? 'red--text' : ''" @click="(disableSubmitButton || showContractImportSection) ? '' : prepareManpowerandServiceWithdrawalUpdate(props.item)">
                            <td style="font-size: 12px;">{{ props.index + 1 }}</td>
                            <td style="font-size: 12px;">{{ props.item.role_name }}</td>
                            <td style="font-size: 12px;" class="text-center">{{ props.item.headcount }}</td>
                            <td style="font-size: 12px;" class="text-center">{{ props.item.ser_type }}</td>
                            <td style="font-size: 12px;">{{ props.item.vendorsupplier_name }}</td>
                            <td style="font-size: 12px;" class="text-center">{{ props.item.is_deb_informed ? 'Yes' : 'No' }}</td>
                            <td style="font-size: 12px;" class="text-center">{{ props.item.deb_informed_dt ? handy.formatDate(props.item.deb_informed_dt) : '-' }}</td>
                            <td style="font-size: 12px;" class="text-center">{{ props.item.deb_status }}</td>
                            <td style="font-size: 12px;">{{ props.item.deb_remarks ? props.item.deb_remarks : '-' }}</td>
                          </tr>
                        </template>
                        </v-data-table>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                    <!-- Document Upload Expansion Panel -->
                    <v-expansion-panel>
                      <v-expansion-panel-header style="min-height: 40px;" class="py-0 grey lighten-4">
                        <div class="subtitle font-weight-bold">Documents</div>
                        <v-flex xs2 class="text-right" v-if="config.IS_EDITED_BY_USER">
                          <v-tooltip top>
                            <template v-slot:activator="{ on }">
                              <v-btn v-on="on" class="warning--text" icon small onclick="event.stopPropagation()" :disabled="disableSubmitButton || showContractImportSection" @click="prepareUploadDocs()"><v-icon>mdi-playlist-plus</v-icon></v-btn>
                            </template>
                            <span>Add New Document</span>
                          </v-tooltip>
                        </v-flex>
                      </v-expansion-panel-header>
                      <v-expansion-panel-content class="mt-2 px-0">
                        <v-data-table
                        :headers="docItemHeader"
                        :items="docItemList"
                        hide-default-footer
                        hide-default-header
                        disable-pagination
                        dense
                        :mobile-breakpoint="0">
                          <template v-slot:header="{ props: { headers } }">
                            <thead>
                              <tr>
                                <th class="grey lighten-4 primary--text" style="font-size: 13px; width: 50px; text-align: center ">{{headers[0].text}}</th>
                                <th class="grey lighten-4 primary--text" style="font-size: 13px; width: 250px; text-align: left ">{{headers[1].text}}</th>
                                <th class="grey lighten-4 primary--text" style="font-size: 13px; width: 120px; text-align: center ">{{headers[2].text}}</th>
                                <th class="grey lighten-4 primary--text" style="font-size: 13px; width: 150; text-align: left ">{{headers[3].text}}</th>
                                <th class="grey lighten-4 primary--text" style="font-size: 13px; width: 100; text-align: center ">{{headers[4].text}}</th>
                                <th class="grey lighten-4 primary--text" style="font-size: 13px; width: 250; text-align: left ">{{headers[5].text}}</th>
                              </tr>
                            </thead>
                          </template>
                          <template slot="item" slot-scope="props">
                            <tr @click="disableSubmitButton || props.item.source != source_var ? '' : updateDocItems(props.item)">
                              <td style="text-align:center; font-size: 12px;">{{ props.index + 1 }}</td>
                              <td style="text-align:left; font-size: 12px;">{{ props.item.file_name }}</td>
                              <td style="text-align:center;"><a :href="handy.loadImg(props.item.file_url)" download style="text-decoration: none;">
                                <v-btn small icon onclick="event.stopPropagation()" class="mr-1 info grey--text text--lighten-4">
                                  <v-icon small>mdi-download</v-icon>
                                </v-btn>
                              </a></td>
                              <td style="text-align:left; font-size: 12px;">{{ props.item.mi_doc_type }}</td>
                              <td style="text-align:center; font-size: 12px;">{{ props.item.source }}</td>
                              <td style="text-align:left; font-size: 12px;">{{ props.item.mi_doc_remarks }}</td>
                            </tr>
                          </template>
                        </v-data-table>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-card-text>
                <v-card-actions>
                  <v-btn small v-if="config.IS_EDITED_BY_USER" class="warning" :disabled="(config.ROLE_NAME != 'Super Admin' || lDeboardReviewBase.base_status != 'Closed')" @click="reopenReview()">Re-Open Project Review</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn small :disabled="showContractImportSection" style="width: 100px;" class="success white--text" @click="validateDeboardReview()">Validate</v-btn>
                  <v-btn small v-if="config.IS_EDITED_BY_USER" class="warning" :disabled="disableSubmitButton || showContractImportSection || deboardPlannerReviewItemList.length === 0 || docItemList.length === 0" @click="deboardReview()">Close Project Review</v-btn>
                  <v-btn small :disabled="showContractImportSection" style="width: 100px;" class="uniformchipinfo white--text" @click="prepareDeboardingReviewView()">view</v-btn>
                </v-card-actions>
              </v-card>
            </v-flex>
          </v-layout>
        </v-container>

        <!-- 2. Add or Update deboarding planner sub category -->
        <v-dialog v-model="showDebPlanner" persistent max-width="600px">
          <v-container grid-list-md class="pa-0" fluid full-height>
            <v-flex xs12>
              <v-form ref="lForm" @submit.prevent="saveDeboardingPlannerChanges()">
                <v-card scrollable>
                  <v-card-title style="font-size: 17px" class="grey lighten-2 py-2">
                    {{lDebPlanner.action ? handy.startWithUpper(lDebPlanner.action) : ''}} Deboarding Planner
                    <v-spacer></v-spacer>
                    <v-btn icon small @click.stop="showDebPlanner = false"><v-icon>mdi-close</v-icon></v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                        v-model="lDebPlanner.deb_planner_cat"
                        label="Deboarding Planner Category"
                        hide-details
                        maxlength="100"
                        style="font-size: 14px"
                        :disabled="lDebPlanner.action === 'update' && lDebPlanner.deb_planner_sub_cat_id != null"
                        :rules="[rules.required]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                        v-model="lDebPlanner.deb_planner_sub_cat"
                        label="Deboarding Planner Sub Category"
                        hide-details
                        maxlength="100"
                        style="font-size: 14px"
                        :disabled="lDebPlanner.action === 'update' && lDebPlanner.deb_planner_sub_cat_id != null"
                        :rules="[rules.required]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 class="pt-2">
                        <v-autocomplete
                        v-model="lDebPlanner.deb_responsible_pair_id"
                        label="Responsibility"
                        item-value="emp_id"
                        item-text="disp_short_name"
                        :items="responsibilityEmpList"
                        style="font-size: 14px"
                        hide-details
                        small-chips
                        deletable-chips
                        clearable
                        dense
                        multiple
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs4>
                        <v-dialog ref="planEndDt"
                        persistent v-model="planEndDt"
                        max-width="290px"
                        :return-value.sync="lDebPlanner.deb_plan_end_dt"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                            slot="activator" label="Planned End Date"
                            v-model="lDebPlanner.deb_plan_end_dt"
                            append-icon="mdi-calendar-today"
                            readonly clearable
                            hide-details
                            style="font-size: 14px"
                            v-on="on"
                            required
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="lDebPlanner.deb_plan_end_dt" scrollable
                          first-day-of-week="1"
                          >
                            <v-spacer></v-spacer>
                            <v-btn text @click="planEndDt = false">Cancel</v-btn>
                            <v-btn text color="accent" @click="$refs.planEndDt.save(lDebPlanner.deb_plan_end_dt)">OK</v-btn>
                          </v-date-picker>
                        </v-dialog>
                      </v-flex>
                      <v-flex xs4>
                        <v-dialog ref="actualEndDt"
                        persistent v-model="actualEndDt"
                        max-width="290px"
                        :return-value.sync="lDebPlanner.deb_actual_end_dt"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                            slot="activator" label="Actual End Date"
                            v-model="lDebPlanner.deb_actual_end_dt"
                            append-icon="mdi-calendar-today"
                            readonly clearable
                            hide-details
                            style="font-size: 14px"
                            v-on="on"
                            required
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="lDebPlanner.deb_actual_end_dt" scrollable
                          first-day-of-week="1"
                          >
                            <v-spacer></v-spacer>
                            <v-btn text @click="actualEndDt = false">Cancel</v-btn>
                            <v-btn text color="accent" @click="$refs.actualEndDt.save(lDebPlanner.deb_actual_end_dt)">OK</v-btn>
                          </v-date-picker>
                        </v-dialog>
                      </v-flex>
                      <v-flex xs4>
                        <v-autocomplete
                        v-model="lDebPlanner.deb_status"
                        :items="status_list"
                        label="Status"
                        hide-details
                        style="font-size: 14px"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                        v-model="lDebPlanner.deb_remarks"
                        label="Add Remarks if any?"
                        hide-details
                        maxlength="1000"
                        style="font-size: 14px"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn type="submit" color="accent" v-if="config.IS_EDITED_BY_USER">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-flex>
          </v-container>
        </v-dialog>

        <!-- 3. Import Deboarding planner details from config -->
        <v-dialog v-model="showListOfDeboardingPlannerDet" persistent scrollable max-width="750px">
          <v-card>
            <v-card-title style="font-size: 17px" class="py-2 grey lighten-3">
              Select Deboarding Planner
              <v-spacer></v-spacer>
              <v-btn icon small @click="showListOfDeboardingPlannerDet = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-text class="pa-3">
              <v-data-table
              v-model="selected"
              show-select
              :headers="deboardingPlannerDetHeadList"
              :items="deboardingPlannerDetList"
              hide-default-footer
              disable-sort
              disable-pagination
              dense
              item-key="mi_deboard_sub_cat_id"
              class="elevation-1 importtableth importtabletd"
              style="font-size: 14px"
              :mobile-break-point="0">
              </v-data-table>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="accent" :disabled="beingSaved" @click="importToDeboardingPlanner(selected)">Import to Deboarding Planner</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- 4. Update onboarding planner - Asset recovery details -->
        <v-dialog v-model="showOnbPlannerAssetRecovery" persistent max-width="600px">
          <v-container grid-list-md class="pa-0" fluid full-height>
            <v-flex xs12>
              <v-form ref="lForm" @submit.prevent="saveOnbPlannerAssetRecoveryChanges()">
                <v-card scrollable>
                  <v-card-title style="font-size: 17px" class="grey lighten-2 py-2">
                    {{lOnbPlannerAssetRecovery.action ? handy.startWithUpper(lOnbPlannerAssetRecovery.action) : ''}} Asset Recovery Detail
                    <v-spacer></v-spacer>
                    <v-btn icon small @click.stop="showOnbPlannerAssetRecovery = false"><v-icon>mdi-close</v-icon></v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                        v-model="lOnbPlannerAssetRecovery.onb_planner_cat"
                        label="Onboarding Planner Category"
                        hide-details
                        maxlength="100"
                        style="font-size: 14px"
                        :disabled="lOnbPlannerAssetRecovery.action === 'update'"
                        :rules="[rules.required]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                        v-model="lOnbPlannerAssetRecovery.onb_planner_sub_cat"
                        label="Onboarding Planner Sub Category"
                        hide-details
                        maxlength="100"
                        style="font-size: 14px"
                        :disabled="lOnbPlannerAssetRecovery.action === 'update'"
                        :rules="[rules.required]"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs4>
                        <v-checkbox hide-details
                        label="Is Uniservice Asset?"
                        v-model="lOnbPlannerAssetRecovery.mi_is_asset_recoverable"
                        class="my-label-text-size"
                        :disabled="lOnbPlannerAssetRecovery.action === 'update'"
                        >
                        </v-checkbox>
                      </v-flex>
                      <v-flex xs4>
                        <v-autocomplete
                        v-model="lOnbPlannerAssetRecovery.mi_is_asset_recovered"
                        :items="asset_recovery_status_list"
                        label="Recovery Status"
                        hide-details
                        style="font-size: 14px"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs4>
                        <v-dialog ref="assetRecoveryDt"
                        persistent v-model="assetRecoveryDt"
                        max-width="290px"
                        :return-value.sync="lOnbPlannerAssetRecovery.mi_asset_recovered_dt"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                            slot="activator" label="Planned End Date"
                            v-model="lOnbPlannerAssetRecovery.mi_asset_recovered_dt"
                            append-icon="mdi-calendar-today"
                            readonly clearable
                            hide-details
                            style="font-size: 14px"
                            v-on="on"
                            required
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="lOnbPlannerAssetRecovery.mi_asset_recovered_dt" scrollable
                          first-day-of-week="1"
                          >
                            <v-spacer></v-spacer>
                            <v-btn text @click="assetRecoveryDt = false">Cancel</v-btn>
                            <v-btn text color="accent" @click="$refs.assetRecoveryDt.save(lOnbPlannerAssetRecovery.mi_asset_recovered_dt)">OK</v-btn>
                          </v-date-picker>
                        </v-dialog>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                        v-model="lOnbPlannerAssetRecovery.mi_asset_rec_remarks"
                        label="Add Remarks if any?"
                        hide-details
                        maxlength="1000"
                        style="font-size: 14px"
                        :rules="[rules.required]"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn type="submit" color="accent" v-if="config.IS_EDITED_BY_USER">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-flex>
          </v-container>
        </v-dialog>

        <!-- 5. Update Outsourced manpower and service withdrown details -->
        <v-dialog v-model="showManpowerandServiceWithdrawal" persistent max-width="600px">
          <v-container grid-list-md class="pa-0" fluid full-height>
            <v-flex xs12>
              <v-form ref="lForm" @submit.prevent="saveManpowerandServiceWithdrawalChanges()">
                <v-card scrollable>
                  <v-card-title style="font-size: 17px" class="grey lighten-2 py-2">
                    {{lManpowerandServiceWithdrawalItemList.action ? handy.startWithUpper(lManpowerandServiceWithdrawalItemList.action) : ''}} Vendor Notification Detail
                    <v-spacer></v-spacer>
                    <v-btn icon small @click.stop="showManpowerandServiceWithdrawal = false"><v-icon>mdi-close</v-icon></v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex xs12>
                        <v-text-field
                        v-model="lManpowerandServiceWithdrawalItemList.role_name"
                        label="Role / Service Name"
                        hide-details
                        maxlength="100"
                        style="font-size: 14px"
                        :disabled="lManpowerandServiceWithdrawalItemList.action === 'update'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs4>
                        <v-text-field
                        v-model="lManpowerandServiceWithdrawalItemList.headcount"
                        label="Head Count"
                        hide-details
                        maxlength="100"
                        style="font-size: 14px"
                        :disabled="lManpowerandServiceWithdrawalItemList.action === 'update'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs4>
                        <v-text-field
                        v-model="lManpowerandServiceWithdrawalItemList.ser_type"
                        label="Service Type"
                        hide-details
                        maxlength="100"
                        style="font-size: 14px"
                        :disabled="lManpowerandServiceWithdrawalItemList.action === 'update'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs4>
                        <v-text-field
                        v-model="lManpowerandServiceWithdrawalItemList.amount"
                        label="Amount per Head Count"
                        hide-details
                        maxlength="100"
                        style="font-size: 14px"
                        :disabled="lManpowerandServiceWithdrawalItemList.action === 'update'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                        v-model="lManpowerandServiceWithdrawalItemList.vendorsupplier_name"
                        label="Vendor Name"
                        hide-details
                        maxlength="100"
                        style="font-size: 14px"
                        :disabled="lManpowerandServiceWithdrawalItemList.action === 'update'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs4>
                        <v-checkbox hide-details
                        label="Is Vendor Informed?"
                        v-model="lManpowerandServiceWithdrawalItemList.is_deb_informed"
                        class="my-label-text-size"
                        >
                        </v-checkbox>
                      </v-flex>
                      <v-flex xs4>
                        <v-dialog ref="mandepSerWithdrawalDt"
                        persistent v-model="mandepSerWithdrawalDt"
                        max-width="290px"
                        :return-value.sync="lManpowerandServiceWithdrawalItemList.deb_informed_dt"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                            slot="activator" label="Informed Date"
                            v-model="lManpowerandServiceWithdrawalItemList.deb_informed_dt"
                            append-icon="mdi-calendar-today"
                            readonly clearable
                            hide-details
                            style="font-size: 14px"
                            v-on="on"
                            required
                            ></v-text-field>
                          </template>
                          <v-date-picker v-model="lManpowerandServiceWithdrawalItemList.deb_informed_dt" scrollable
                          first-day-of-week="1"
                          >
                            <v-spacer></v-spacer>
                            <v-btn text @click="mandepSerWithdrawalDt = false">Cancel</v-btn>
                            <v-btn text color="accent" @click="$refs.mandepSerWithdrawalDt.save(lManpowerandServiceWithdrawalItemList.deb_informed_dt)">OK</v-btn>
                          </v-date-picker>
                        </v-dialog>
                      </v-flex>
                      <v-flex xs4>
                        <v-autocomplete
                        v-model="lManpowerandServiceWithdrawalItemList.deb_status"
                        :items="mandep_ser_withdraw_status_list"
                        label="Withdrawal Status"
                        hide-details
                        style="font-size: 14px"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                        v-model="lManpowerandServiceWithdrawalItemList.deb_remarks"
                        label="Add Remarks if any?"
                        hide-details
                        maxlength="1000"
                        style="font-size: 14px"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions class="pt-0">
                    <v-spacer></v-spacer>
                    <v-btn type="submit" color="accent" v-if="config.IS_EDITED_BY_USER">Save</v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-flex>
          </v-container>
        </v-dialog>

        <!-- 6. Upload Documents -->
        <v-dialog v-model="showDeboardingDocUpload" persistent scrollable max-width="700px">
          <v-card>
            <v-card-title style="font-size: 17px" class="py-2 grey lighten-3">
              Documents Upload
              <v-spacer></v-spacer>
              <v-btn icon small @click="showDeboardingDocUpload = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-text class="pa-3">
              <v-flex xs12>
                <input style="display:none" type="file" ref="fileInput"
                accept=".xls, .eml, .xlsx, .pdf, .doc, .docx, image/png, image/gif, image/jpeg" multiple @change="loadFilesFromFileBrowser(lUploadDoc)"/>
                <v-btn icon @click="pickFile"><v-icon>mdi-attachment</v-icon></v-btn>
                <span v-if="lUploadDoc.files && lUploadDoc.files.filter(rec => rec.is_selected).length > 0">
                  <span v-for="(file, index) in lUploadDoc.files.filter(rec => rec.is_selected)" :key="index">
                    <v-chip style="font-size: 12px;" v-model="file.is_selected" @click:close="removeSelectedFile(file)" close>{{ file.file_name }}</v-chip>
                  </span>
                </span>
                <span v-else>Attachment if any<br /><span class="caption">(supports images, pdfs, docs and excels upto 20MB)</span></span>
              </v-flex>
              <v-flex xs12>
                <v-autocomplete
                v-model="lUploadDoc.mi_doc_type"
                label="Doc Type"
                :items="doc_type_list"
                hide-details
                style="font-size: 14px"
                :rules="[rules.required]"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                v-model="lUploadDoc.mi_doc_remarks"
                label="Remarks"
                hide-details
                maxlength="250"
                style="font-size: 14px"
                ></v-textarea>
              </v-flex>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="accent" :disabled="beingSaved" @click="saveUploadedDocs()">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- 7. Basic Information of Commnunity -->
        <v-dialog v-model="showCommunityInfo" persistent max-width="500px">
          <v-container grid-list-md class="pa-0" fluid full-height>
            <v-flex xs12>
              <v-card>
                <v-card-title style="font-size: 17px" class="py-0 grey lighten-3">
                  Community Information
                  <v-spacer></v-spacer>
                  <v-btn icon @click="showCommunityInfo = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>
                <v-card-text class="pb-1 body-1">
                  <v-container grid-list-md class="pa-2">
                    <v-layout row wrap>
                      <v-flex xs6>
                        <span class="caption grey--text">Community Id.</span><br />
                        <span style="font-size: 14px" class="black--text">{{ commBasicInformationList.comm_id }}</span>
                      </v-flex>
                      <v-flex xs6>
                        <span class="caption grey--text">Community Name</span><br />
                        <span style="font-size: 14px" class="black--text">{{ commBasicInformationList.comm_name }}</span>
                      </v-flex>
                      <v-flex xs6>
                        <span class="caption grey--text">Community Type</span><br />
                        <span style="font-size: 14px" class="black--text">{{ commBasicInformationList.comm_type }}</span>
                      </v-flex>
                      <v-flex xs6>
                        <span class="caption grey--text">Community Address</span><br />
                        <span style="font-size: 14px" class="black--text">{{ commBasicInformationList.address }}</span>
                      </v-flex>
                      <v-flex xs6>
                        <span class="caption grey--text">No of Units</span><br />
                        <span style="font-size: 14px" class="black--text">{{ commBasicInformationList.no_of_unit }}</span>
                      </v-flex>
                      <v-flex xs6>
                        <span class="caption grey--text">Customer Since</span><br />
                        <span style="font-size: 14px" class="black--text">{{ commBasicInformationList.cust_since ? handy.formatDate(commBasicInformationList.cust_since) : ''}}</span>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-container>
        </v-dialog>

        <!-- 8. Basic Information of Project -->
        <v-dialog v-model="showProjectInfo" persistent max-width="500px">
          <v-container grid-list-md class="pa-0" fluid full-height>
            <v-flex xs12>
              <v-card>
                <v-card-title style="font-size: 17px" class="py-0 grey lighten-3">
                  Project Information
                  <v-spacer></v-spacer>
                  <v-btn icon @click="showProjectInfo = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>
                <v-card-text class="pb-1 body-1">
                  <v-container grid-list-md class="pa-2">
                    <v-layout row wrap>
                      <v-flex xs6>
                        <span class="caption grey--text">Project Id.</span><br />
                        <span style="font-size: 14px" class="black--text">{{ projBasicInformationList.proj_id }}</span>
                      </v-flex>
                      <v-flex xs6>
                        <span class="caption grey--text">Project Name</span><br />
                        <span style="font-size: 14px" class="black--text">{{ projBasicInformationList.proj_name }}</span>
                      </v-flex>
                      <v-flex xs6>
                        <span class="caption grey--text">Project Type</span><br />
                        <span style="font-size: 14px" class="black--text">{{ projBasicInformationList.proj_type }}</span>
                      </v-flex>
                      <v-flex xs6>
                        <span class="caption grey--text">Project Status</span><br />
                        <span style="font-size: 14px" class="black--text">{{ projBasicInformationList.proj_status }}</span>
                      </v-flex>
                      <v-flex xs6>
                        <span class="caption grey--text">Project Manager</span><br />
                        <span style="font-size: 14px" class="black--text">{{ projBasicInformationList.emp_name }}</span>
                      </v-flex>
                      <v-flex xs6>
                        <span class="caption grey--text">Project Start</span><br />
                        <span style="font-size: 14px" class="black--text">{{ projBasicInformationList.proj_start ? handy.formatDate(projBasicInformationList.proj_start) : '' }}</span>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-container>
        </v-dialog>

        <!-- 9. Basic information of Project Contract -->
        <v-dialog v-model="showProjectContractInfo" persistent max-width="600px">
          <v-container grid-list-md class="pa-0" fluid full-height>
            <v-flex xs12>
              <v-card>
                <v-card-title style="font-size: 17px" class="py-0 grey lighten-3">
                  Project Contract Information
                  <v-spacer></v-spacer>
                  <v-btn icon @click="showProjectContractInfo = false"><v-icon>mdi-close</v-icon></v-btn>
                </v-card-title>
                <v-card-text class="pb-1 body-1">
                  <v-container grid-list-md class="pa-2">
                    <v-layout row wrap>
                      <v-flex xs6>
                        <v-spacer></v-spacer>
                      </v-flex>
                      <v-flex xs6>
                        <v-btn small class="accent" @click="prepareViewProjContract(lDeboardReviewBase)">View Project Contract Detail</v-btn>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs6>
                        <span class="caption grey--text">Project Contract Id.</span><br />
                        <span style="font-size: 14px" class="black--text">{{ projContractInformationList.proj_contract_base_id }}</span>
                      </v-flex>
                      <v-flex xs6>
                        <span class="caption grey--text">Project Contract HeadCount</span><br />
                        <span style="font-size: 14px" class="black--text">{{ projContractInformationList.head_count }}</span>
                      </v-flex>
                      <v-flex xs6>
                        <span class="caption grey--text">Project Contract Status</span><br />
                        <span style="font-size: 14px" class="black--text">{{ projContractInformationList.status }}</span>
                      </v-flex>
                      <v-flex xs6>
                        <span class="caption grey--text">Project Contract Version</span><br />
                        <span style="font-size: 14px" class="black--text">{{ projContractInformationList.version + '.0' }}</span>
                      </v-flex>
                      <v-flex xs6>
                        <span class="caption grey--text">Project Contract Created By</span><br />
                        <span style="font-size: 14px" class="black--text">{{ projContractInformationList.update_by_name + ' on ' + handy.formatDate(projContractInformationList.updated_date) }}</span>
                      </v-flex>
                      <v-flex xs6>
                        <span class="caption grey--text">Project Contract Value</span><br />
                        <span style="font-size: 14px" class="black--text">{{ projContractInformationList.contract_value_with_gst ? handy.formatCur(projContractInformationList.contract_value_with_gst) : '' }}</span>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-flex>
          </v-container>
        </v-dialog>

        <!-- 10. "Project Contract View" based on project_contract_base_id -->
        <v-dialog scrollable v-model="showContractViewAsPdf" max-width="900px">
          <v-card>
            <v-card-title style="font-size: 17px" class="py-2 grey lighten-3">
              Project Contract Detail
              <v-spacer></v-spacer>
              <v-btn icon small @click="showContractViewAsPdf = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-text>
              <v-flex xs12>
                <v-card flat>
                  <v-card-text class="pa-0">
                    <!-- 1st and 2nd view-->
                    <v-flex xs12 style="padding-right: 5px;" v-if="attTab === 'tab-0' || attTab === 'tab-1'">
                      <v-layout row wrap>
                        <v-flex xs12 v-if="projContractView[0] && projContractView[0].length > 0 && projContractView[0][0].proj_contract_sub_category">
                          <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
                            <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;font-weight: semi-bold;">{{projContractView[0][0].heading}}</div>
                            <v-data-table
                            :headers="techHeaders"
                            hide-default-header
                            :items="projContractView[0]"
                            disable-sort
                            hide-default-footer
                            dense
                            disable-pagination>
                              <template v-slot:header="{ props: { headers } }">
                                <thead>
                                  <tr>
                                    <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
                                    <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                                    <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
                                  </tr>
                                </thead>
                              </template>
                              <template slot="item" slot-scope="props">
                                <tr>
                                  <td style="font-size: 12px; color:#000; border-bottom: 1px solid #bebebe; vertical-align: top; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
                                  <td style="font-size: 12px; color:#000; border-bottom: 1px solid #bebebe; vertical-align: top; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
                                  <td style="font-size: 12px; color:#000; border-bottom: 1px solid #bebebe; vertical-align: top; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
                                </tr>
                              </template>
                            </v-data-table>
                            <v-flex xs12>
                              <table width="100%" cellpadding="0" cellspacing="0">
                                <tbody>
                                  <tr style="background-color: #fff; font-family: Arial, Helvetica, sans-serif; color: #000;">
                                    <td style="font-size: 12px; padding: 4px 16px; width: 368px;">Sub Total</td>
                                    <td style="font-size: 12px; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(projContractView[0].total_amount) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                </tbody>
                              </table>
                            </v-flex>
                            <v-flex xs12 v-if="attTab === 'tab-0'">
                              <table width="100%" cellpadding="0" cellspacing="0">
                                <tbody>
                                  <tr style="font-family: Arial, Helvetica, sans-serif; color: #000;" v-for="(mgmt, i) in projContractView[1]" :key="i">
                                    <td style="font-size: 12px; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.tot_amt}} {{handy.formatCur(mgmt.amount)}} on FMS)</td>
                                    <td style="font-size: 12px; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                  <tr style="background-color: #93f0cf; font-family: Arial, Helvetica, sans-serif; color: #09391f;">
                                    <td style="font-size: 12px; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
                                    <td style="font-size: 12px; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(projContractView[0].before_gst) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                  <tr style="font-family: Arial, Helvetica, sans-serif; color: #000;" v-for="gst in projContractView[2]" :key="gst.gst_amt">
                                    <td style="font-size: 12px; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
                                    <td style="font-size: 12px; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(gst.tax_amt) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                  <tr style="background-color: #44cb82; font-family: Arial, Helvetica, sans-serif; color: #fff;">
                                    <td style="font-size: 12px; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[0][0].heading.substring(10, projContractView[0][0].heading.length)}} Grand Total with GST</td>
                                    <td style="font-size: 12px; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(projContractView[0].gst_tax_amt) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                </tbody>
                              </table>
                            </v-flex>
                          </v-flex>
                        </v-flex>
                        <div style="page-break-after:always; clear:both"></div>
                      <v-flex xs12 style="padding-top: 8px;" v-if="projContractView[3] && projContractView[3].length > 0 && projContractView[3][0].staff_role">
                        <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
                          <div style="background-color: #4570d6; padding: 4px 0px; color: #fff; text-align: center; font-family: Arial, Helvetica, sans-serif;">{{projContractView[3][0].heading}}</div>
                          <v-flex xs12>
                            <v-flex xs12 v-for="(cat, i) in categoryListForContractView" :key="i" v-if="projContractView[3].filter(rec => rec.role_cat === cat).length > 0">
                              <div style="padding: 4px 0px; font-size: 12px; font-family: Arial, Helvetica, sans-serif; background-color: #71c1f5; color: #000; text-align: center;">
                                {{handy.startWithUpper(cat.toLowerCase())}}
                              </div>
                              <v-data-table
                              :headers="manpowerHeaders"
                              hide-default-header
                              :items="projContractView[3].filter(rec => rec.role_cat === cat)"
                              hide-default-footer
                              disable-sort
                              dense
                              disable-pagination
                              >
                                <template v-slot:header="{ props: { headers } }">
                                  <thead>
                                    <tr>
                                      <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 150px; text-align: left;">{{headers[0].text}}</th>
                                      <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                                      <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[2].text}}</th>
                                      <th style="background-color: #cee6f5;font-size: 12px; padding-right: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[3].text}}</th>
                                      <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[4].text}}</th>
                                    </tr>
                                  </thead>
                                </template>
                                <template slot="item" slot-scope="props">
                                  <tr>
                                    <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.staff_role }}</td>
                                    <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.head_count }}</td>
                                    <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amt_per_hc }}</td>
                                    <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.total_hc_amt }}</td>
                                    <td style="font-size: 12px; border-bottom: 1px solid #bebebe; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
                                  </tr>
                                </template>
                              </v-data-table>
                            </v-flex>
                            <v-flex xs12>
                              <table width="100%" cellpadding="0" cellspacing="0">
                                <tbody>
                                  <tr style="color: #000;">
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">Sub Total</td>
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(projContractView[3].total_amount) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                </tbody>
                              </table>
                            </v-flex>
                            <v-flex xs12 v-if="attTab === 'tab-0'">
                              <table width="100%" cellpadding="0" cellspacing="0">
                                <tbody>
                                  <tr style="color: #000;" v-for="mgmt in projContractView[4]" :key="mgmt.Mgmt_fee_per">
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.Mgmt_fee_per}} {{handy.formatCur(mgmt.amount)}} on FMS)</td>
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                  <tr style="background-color: #93f0cf; color:#09391f;">
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">Total Before Tax</td>
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(projContractView[3].before_gst) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                  <tr style="color: #000;" v-for="gst in projContractView[5]" :key="gst.gst_amt">
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(gst.tax_amt) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                  <tr style="background-color: #44cb82; color: #fff;">
                                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[3][0].heading.substring(8, projContractView[3][0].heading.length)}} Grand Total with GST</td>
                                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(projContractView[3].gst_tax_amt) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                </tbody>
                              </table>
                            </v-flex>
                          </v-flex>
                        </v-flex>
                      </v-flex>
                      <div style="page-break-after:always; clear:both"></div>
                      <v-flex xs12 style="padding-top: 8px;" v-if="projContractView[6] && projContractView[6].length && projContractView[6][0].staff_role">
                        <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
                          <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">{{projContractView[6][0].heading}}</div>
                          <v-flex xs12 v-if="projContractView[6].filter(rec => rec.role_cat === 'SAFTY/SECURITY').length > 0">
                            <v-divider class="black"></v-divider>
                            <v-data-table
                            :headers="manpowerHeaders"
                            hide-default-header
                            :items="projContractView[6]"
                            disable-sort
                            hide-default-footer
                            dense
                            disable-pagination
                            >
                              <template v-slot:header="{ props: { headers } }">
                                <thead>
                                  <tr>
                                    <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 150px; text-align: left;">{{headers[0].text}}</th>
                                    <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                                    <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[2].text}}</th>
                                    <th style="background-color: #cee6f5;font-size: 12px; padding-right: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[3].text}}</th>
                                    <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[4].text}}</th>
                                  </tr>
                                </thead>
                              </template>
                              <template slot="item" slot-scope="props">
                                <tr>
                                  <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.staff_role }}</td>
                                  <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.head_count }}</td>
                                  <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amt_per_hc }}</td>
                                  <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.total_hc_amt }}</td>
                                  <td style="font-size: 12px; border-bottom: 1px solid #bebebe; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
                                </tr>
                              </template>
                            </v-data-table>
                            <v-flex xs12>
                              <table width="100%" cellpadding="0" cellspacing="0">
                                <tbody>
                                  <tr style="color: #000;">
                                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Sub Total</td>
                                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(projContractView[6].total_amount) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                </tbody>
                              </table>
                            </v-flex>
                            <v-flex xs12 v-if="attTab === 'tab-0'">
                              <table width="100%" cellpadding="0" cellspacing="0">
                                <tbody>
                                  <tr style="color: #000;" v-for="mgmt in projContractView[7]" :key="mgmt.Mgmt_fee_per">
                                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px; width: 100px;">Management fees ({{mgmt.Mgmt_fee_per}} % of {{handy.formatCur(mgmt.amount)}} on FMS)</td>
                                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                  <tr style="background-color: #93f0cf; color:#09391f;">
                                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
                                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(projContractView[6].before_gst) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                  <tr style="color: #000;" v-for="gst in projContractView[8]" :key="gst.gst_amt">
                                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
                                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(gst.tax_amt) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                  <tr style="background-color: #44cb82; color: #fff;">
                                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[6][0].heading.substring(8, projContractView[6][0].heading.length)}} Grand Total with GST</td>
                                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(projContractView[6].gst_tax_amt) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                </tbody>
                              </table>
                            </v-flex>
                          </v-flex>
                        </v-flex>
                      </v-flex>
                      <div style="page-break-after:always; clear:both"></div>
                      <v-flex xs12 style="padding-top: 8px;" v-if="projContractView[9] && projContractView[9].length && projContractView[9][0].proj_contract_sub_category">
                        <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
                          <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">{{projContractView[9][0].heading}}</div>
                          <v-data-table
                          :headers="techHeaders"
                          hide-default-header
                          disable-sort
                          :items="projContractView[9]"
                          hide-default-footer
                          dense
                          disable-pagination
                          >
                            <template v-slot:header="{ props: { headers } }">
                              <thead>
                                <tr>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
                                </tr>
                              </thead>
                            </template>
                            <template slot="item" slot-scope="props">
                              <tr>
                                <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
                                <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
                                <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
                              </tr>
                            </template>
                          </v-data-table>
                          <v-flex xs12>
                            <table width="100%" cellpadding="0" cellspacing="0">
                              <tbody>
                                <tr style="color: #000;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Sub Total</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[9].total_amount) }}
                                  </td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </table>
                          </v-flex>
                          <v-flex xs12 v-if="attTab === 'tab-0'">
                            <table width="100%" cellpadding="0" cellspacing="0">
                              <tbody>
                                <tr style="color: #000;" v-for="mgmt in projContractView[10]" :key="mgmt.Mgmt_fee_per">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.tot_amt}} {{handy.formatCur(mgmt.amount)}} on FMS)</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="background-color: #93f0cf; color:#09391f;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[9].before_gst) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="color: #000;" v-for="gst in projContractView[11]" :key="gst.gst_amt">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(gst.tax_amt) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="background-color: #44cb82; color: #fff;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[9][0].heading.substring(21, projContractView[9][0].heading.length)}} Grand Total with GST</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[9].gst_tax_amt) }}
                                  </td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </table>
                          </v-flex>
                        </v-flex>
                      </v-flex>
                      <div style="page-break-after:always; clear:both"></div>
                      <v-flex xs12 style="padding-top: 8px;" v-if="projContractView[12] && projContractView[12].length && projContractView[12][0].proj_contract_sub_category">
                        <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
                          <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">{{projContractView[12][0].heading}}</div>
                          <v-data-table
                          :headers="techHeaders"
                          hide-default-header
                          disable-sort
                          :items="projContractView[12]"
                          hide-default-footer
                          dense
                          disable-pagination
                          >
                            <template v-slot:header="{ props: { headers } }">
                              <thead>
                                <tr>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
                                </tr>
                              </thead>
                            </template>
                            <template slot="item" slot-scope="props">
                              <tr>
                                <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
                                <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
                                <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
                              </tr>
                            </template>
                          </v-data-table>
                          <v-flex xs12>
                            <table width="100%" cellpadding="0" cellspacing="0">
                              <tbody>
                                <tr style="color: #000;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Sub Total</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[12].total_amount) }}
                                  </td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </table>
                          </v-flex>
                          <v-flex xs12 v-if="attTab === 'tab-0'">
                            <table width="100%" cellpadding="0" cellspacing="0">
                              <tbody>
                                <tr style="color: #000;" v-for="mgmt in projContractView[13]" :key="mgmt.Mgmt_fee_per">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.tot_amt}} % of {{handy.formatCur(mgmt.amount)}} on FMS)</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="background-color: #93f0cf; color:#09391f;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[12].before_gst) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="color: #000;" v-for="gst in projContractView[14]" :key="gst.gst_amt">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(gst.tax_amt) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="background-color: #44cb82; color: #fff;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[12][0].heading.substring(13, projContractView[12][0].heading.length)}} Grand Total with GST</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[12].gst_tax_amt) }}
                                  </td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </table>
                          </v-flex>
                        </v-flex>
                      </v-flex>
                      <div style="page-break-after:always; clear:both"></div>
                      <v-flex xs12 style="padding-top: 8px;" v-if="projContractView[15] && projContractView[15].length && projContractView[15][0].proj_contract_sub_category">
                        <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
                          <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">{{projContractView[15][0].heading}}</div>
                          <v-data-table
                          :headers="techHeaders"
                          hide-default-header
                          disable-sort
                          :items="projContractView[15]"
                          hide-default-footer
                          dense
                          disable-pagination
                          >
                            <template v-slot:header="{ props: { headers } }">
                              <thead>
                                <tr>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
                                </tr>
                              </thead>
                            </template>
                            <template slot="item" slot-scope="props">
                              <tr>
                                <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
                                <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
                                <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
                              </tr>
                            </template>
                          </v-data-table>
                          <v-flex xs12>
                            <table width="100%" cellpadding="0" cellspacing="0">
                              <tbody>
                                <tr style="color: #000;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Sub Total</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[15].total_amount) }}
                                  </td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </table>
                          </v-flex>
                          <v-flex xs12 v-if="attTab === 'tab-0'">
                            <table width="100%" cellpadding="0" cellspacing="0">
                              <tbody>
                                <tr style="color: #000;" v-for="mgmt in projContractView[16]" :key="mgmt.Mgmt_fee_per">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.tot_amt}} {{handy.formatCur(mgmt.amount)}} on FMS)</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="background-color: #93f0cf; color:#09391f;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[15].before_gst) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="color: #000;" v-for="gst in projContractView[17]" :key="gst.gst_amt">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(gst.tax_amt) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="background-color: #44cb82; color: #fff;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[15][0].heading.substring(13, projContractView[15][0].heading.length)}} Grand Total with GST</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[15].gst_tax_amt) }}
                                  </td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </table>
                          </v-flex>
                        </v-flex>
                      </v-flex>
                      <div style="page-break-after:always; clear:both"></div>
                      <v-flex xs12 style="padding-top: 8px;" v-if="projContractView[18] && projContractView[18].length && projContractView[18][0].proj_contract_sub_category">
                        <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
                          <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">{{projContractView[18][0].heading}}</div>
                          <v-data-table
                          :headers="techHeaders"
                          hide-default-header
                          disable-sort
                          :items="projContractView[18]"
                          hide-default-footer
                          dense
                          disable-pagination
                          >
                            <template v-slot:header="{ props: { headers } }">
                              <thead>
                                <tr>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
                                </tr>
                              </thead>
                            </template>
                            <template slot="item" slot-scope="props">
                              <tr>
                                <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
                                <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
                                <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
                              </tr>
                            </template>
                          </v-data-table>
                          <v-flex xs12>
                            <table width="100%" cellpadding="0" cellspacing="0">
                              <tbody>
                                <tr style="color: #000;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Sub Total</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[18].total_amount) }}
                                  </td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </table>
                          </v-flex>
                          <v-flex xs12 v-if="attTab === 'tab-0'">
                            <table width="100%" cellpadding="0" cellspacing="0">
                              <tbody>
                                <tr style="color: #000;" v-for="mgmt in projContractView[19]" :key="mgmt.Mgmt_fee_per">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.tot_amt}} {{handy.formatCur(mgmt.amount)}} on FMS)</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="background-color: #93f0cf; color:#09391f;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[18].before_gst) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="color: #000;" v-for="gst in projContractView[20]" :key="gst.gst_amt">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(gst.tax_amt) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="background-color: #44cb82; color: #fff;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[18][0].heading.substring(5, projContractView[18][0].heading.length)}} Grand Total with GST</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[18].gst_tax_amt) }}
                                  </td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </table>
                          </v-flex>
                        </v-flex>
                      </v-flex>
                      <div style="page-break-after:always; clear:both"></div>
                      <v-flex xs12 style="padding-top: 8px;" v-if="projContractView[21] && projContractView[21].length && projContractView[21][0].proj_contract_sub_category">
                        <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
                          <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">{{projContractView[21][0].heading}}</div>
                          <v-data-table
                          :headers="techHeaders"
                          hide-default-header
                          disable-sort
                          :items="projContractView[21]"
                          hide-default-footer
                          dense
                          disable-pagination
                          >
                            <template v-slot:header="{ props: { headers } }">
                              <thead>
                                <tr>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
                                </tr>
                              </thead>
                            </template>
                            <template slot="item" slot-scope="props">
                              <tr>
                                <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
                                <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
                                <td style="font-size: 12px; border-bottom: 1px solid #bebebe; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
                              </tr>
                            </template>
                          </v-data-table>
                          <v-flex xs12>
                            <table width="100%" cellpadding="0" cellspacing="0">
                              <tbody>
                                <tr style="color: #000;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Sub Total</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[21].total_amount) }}
                                  </td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </table>
                          </v-flex>
                          <v-flex xs12 v-if="attTab === 'tab-0'">
                            <table width="100%" cellpadding="0" cellspacing="0">
                              <tbody>
                                <tr style="color: #000;" v-for="mgmt in projContractView[22]" :key="mgmt.Mgmt_fee_per">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.tot_amt}} {{handy.formatCur(mgmt.amount)}} on FMS)</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="background-color: #93f0cf; color:#09391f;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[21].before_gst) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="color: #000;" v-for="gst in projContractView[23]" :key="gst.gst_amt">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(gst.tax_amt) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="background-color: #44cb82; color: #fff;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[21][0].heading.substring(20, projContractView[21][0].heading.length)}} Grand Total with GST</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[21].gst_tax_amt) }}
                                  </td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </table>
                          </v-flex>
                        </v-flex>
                      </v-flex>
                      <div style="page-break-after:always; clear:both"></div>
                      <v-flex xs12 style="padding-top: 8px;" v-if="projContractView[24] && projContractView[24].length && projContractView[24][0].proj_contract_sub_category">
                        <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
                          <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">{{projContractView[24][0].heading}}</div>
                          <v-data-table
                          :headers="techHeaders"
                          hide-default-header
                          disable-sort
                          :items="projContractView[24]"
                          hide-default-footer
                          dense
                          disable-pagination
                          >
                            <template v-slot:header="{ props: { headers } }">
                              <thead>
                                <tr>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
                                </tr>
                              </thead>
                            </template>
                            <template slot="item" slot-scope="props">
                              <tr>
                                <td style="font-size: 12px; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
                                <td style="font-size: 12px; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
                                <td style="font-size: 12px; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
                              </tr>
                            </template>
                          </v-data-table>
                          <v-flex xs12>
                            <table width="100%" cellpadding="0" cellspacing="0">
                              <tbody>
                                <tr style="color: #000;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Sub Total</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[24].total_amount) }}
                                  </td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </table>
                          </v-flex>
                          <v-flex xs12 v-if="attTab === 'tab-0'">
                            <table width="100%" cellpadding="0" cellspacing="0">
                              <tbody>
                                <tr style="color: #000;" v-for="mgmt in projContractView[25]" :key="mgmt.Mgmt_fee_per">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management fees ({{mgmt.tot_amt}} {{handy.formatCur(mgmt.amount)}} on FMS)</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(mgmt.Mgmt_fee_amt) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="background-color: #93f0cf; color:#09391f;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[24].before_gst) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="color: #000;" v-for="gst in projContractView[26]" :key="gst.gst_amt">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST {{gst.tax_per}} % of {{handy.formatCur(gst.gst_amt)}}</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(gst.tax_amt) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="background-color: #44cb82; color: #fff;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">{{projContractView[24][0].heading.substring(9, projContractView[24][0].heading.length)}} Grand Total with GST</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[24].gst_tax_amt) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="background-color: #44cb82; color: #fff;">
                                  <td colspan="3"></td>
                                </tr>
                              </tbody>
                            </table>
                          </v-flex>
                        </v-flex>
                      </v-flex>
                      <!-- SUMMARY -->
                      <div style="page-break-after:always; clear:both"></div>
                      <v-flex xs12 style="padding-top: 8px; padding-bottom: 12px;" v-if="projContractView[27] && projContractView[27][0].sub_total">
                        <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
                          <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">SUMMARY</div>
                          <table width="100%" cellpadding="0" cellspacing="0">
                            <tbody>
                              <tr style="color: #000;">
                                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Grand Total</td>
                                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                  {{ handy.formatCur(projContractView[27][0].sub_total) }}
                                </td>
                                <td></td>
                              </tr>
                              <tr style="color: #000;">
                                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management Fee</td>
                                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                  {{ handy.formatCur(projContractView[27][0].mgmt_fee) }}
                                </td>
                                <td></td>
                              </tr>
                              <tr style="background-color: #93f0cf; color:#09391f;">
                                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Total Before Tax</td>
                                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                  {{ handy.formatCur(projContractView[27][0].before_gst) }}
                                </td>
                                <td></td>
                              </tr>
                              <tr style="color: #000;">
                                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST</td>
                                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                  {{ handy.formatCur(projContractView[27][0].tax_amt) }}
                                </td>
                                <td></td>
                              </tr>
                              <tr style="background-color: #44cb82; color: #fff;">
                                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Grand Total After GST</td>
                                <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                  {{ handy.formatCur(projContractView[27][0].after_gst) }}
                                </td>
                                <td></td>
                              </tr>
                            </tbody>
                          </table>
                        </v-flex>
                      </v-flex>
                      <v-flex xs12 v-else>
                        <div>
                          No Data Available
                        </div>
                      </v-flex>
                      </v-layout>
                    </v-flex>

                    <!-- 3rd view -->
                    <v-flex xs12 style="padding-right: 5px;" v-if="attTab === 'tab-2'">
                      <v-layout row wrap>
                        <v-flex xs12 style="border: 1px solid black; border-radius: 0px;" v-if="projContractView[27] && projContractView[27][0].sub_total">
                          <v-data-table
                          :headers="manpowerHeaders"
                          hide-default-header
                          disable-sort
                          :items="projContractView[0].concat(projContractView[3]).concat(projContractView[6]).concat(projContractView[9]).concat(projContractView[12]).concat(projContractView[15]).concat(projContractView[18]).concat(projContractView[21]).concat(projContractView[24])"
                          hide-default-footer
                          dense
                          disable-pagination>
                            <template v-slot:header="{ props: { headers } }">
                              <thead>
                                <tr>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 150px; text-align: left;">{{headers[0].text}}</th>
                                  <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                                  <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[2].text}}</th>
                                  <th style="background-color: #cee6f5;font-size: 12px; padding-right: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[3].text}}</th>
                                  <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[4].text}}</th>
                                </tr>
                              </thead>
                            </template>
                            <template slot="item" slot-scope="props">
                              <tr v-if="props.item.staff_role || props.item.proj_contract_sub_category">
                                <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.staff_role ? props.item.staff_role : props.item.proj_contract_sub_category }}</td>
                                <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.head_count ? props.item.head_count : 1 }}</td>
                                <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amt_per_hc ? props.item.amt_per_hc : props.item.amount }}</td>
                                <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.total_hc_amt ? props.item.total_hc_amt : props.item.amount }}</td>
                                <td style="border-bottom: 1px solid #bebebe; font-size: 12px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
                              </tr>
                            </template>
                          </v-data-table>
                        </v-flex>
                        <div style="page-break-after:always; clear:both"></div>
                        <v-flex xs12 style="padding-top: 8px; padding-bottom: 12px;" v-if="projContractView[27] && projContractView[27][0].sub_total">
                          <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
                            <div style="background-color: #4570d6; padding: 4px 0px; font-family: Arial, Helvetica, sans-serif; color: #fff; text-align: center;">SUMMARY</div>
                            <table width="100%" cellpadding="0" cellspacing="0">
                              <tbody>
                                <tr style="color: #000;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Grand Total</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[27][0].sub_total) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="color: #000;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Management Fee</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[27][0].mgmt_fee) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="background-color: #93f0cf; color:#09391f;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px; color:#09391f;">Total Before Tax</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[27][0].before_gst) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="color: #000;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">GST</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[27][0].tax_amt) }}
                                  </td>
                                  <td></td>
                                </tr>
                                <tr style="background-color: #44cb82; color: #fff;">
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Grand Total After GST</td>
                                  <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                    {{ handy.formatCur(projContractView[27][0].after_gst) }}
                                  </td>
                                  <td></td>
                                </tr>
                              </tbody>
                            </table>
                          </v-flex>
                        </v-flex>
                        <v-flex xs12 v-else>
                          <div>
                            No Data Available
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-flex>

                    <!-- 4th view -->
                    <v-flex xs12 style="padding-right: 5px;" v-if="attTab === 'tab-3'">
                      <v-layout row wrap>
                        <v-flex xs12 v-if="(projContractView[3] && projContractView[3].length > 0  && projContractView[3][0].staff_role) || (projContractView[6] && projContractView[6].length > 0 && projContractView[6][0].staff_role)">
                          <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
                            <div style="background-color: #4570d6; padding: 4px 0px; color: #fff; text-align: center; font-family: Arial, Helvetica, sans-serif;">MANPOWER</div>
                            <v-data-table
                            :headers="manpowerHeaders"
                            hide-default-header
                            disable-sort
                            :items="projContractView[3].concat(projContractView[6])"
                            hide-default-footer
                            dense
                            disable-pagination>
                              <template v-slot:header="{ props: { headers } }">
                                <thead>
                                  <tr>
                                    <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 150px; text-align: left;">{{headers[0].text}}</th>
                                    <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                                    <th style="background-color: #cee6f5;font-size: 12px; padding: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[2].text}}</th>
                                    <th style="background-color: #cee6f5;font-size: 12px; padding-right: 0px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[3].text}}</th>
                                    <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[4].text}}</th>
                                  </tr>
                                </thead>
                              </template>
                              <template slot="item" slot-scope="props">
                                <tr>
                                  <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.staff_role }}</td>
                                  <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.head_count }}</td>
                                  <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amt_per_hc }}</td>
                                  <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: right; padding-right: 0px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.total_hc_amt }}</td>
                                  <td style="border-bottom: 1px solid #bebebe; font-size: 12px; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
                                </tr>
                              </template>
                            </v-data-table>
                            <v-flex xs12>
                              <table width="100%" cellpadding="0" cellspacing="0">
                                <tbody>
                                  <tr style="color: #000;">
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">Sub Total</td>
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur((projContractView[3].total_amount ? projContractView[3].total_amount : 0) + (projContractView[6].total_amount ? projContractView[6].total_amount : 0)) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                  <tr style="color: #000;">
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">Management fees</td>
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur((projContractView[3].mgmt ? projContractView[3].mgmt : 0) + (projContractView[6].mgmt ? projContractView[6].mgmt : 0)) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                  <tr style="background-color: #93f0cf; color:#09391f;">
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px; color:#09391f;">Total Before Tax</td>
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur((projContractView[3].before_gst ? projContractView[3].before_gst : 0) + (projContractView[6].before_gst ? projContractView[6].before_gst : 0)) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                  <tr style="color: #000;">
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">GST</td>
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur((projContractView[3].tax_amt ? projContractView[3].tax_amt : 0) + (projContractView[6].tax_amt ? projContractView[6].tax_amt : 0)) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                  <tr style="background-color: #44cb82; color: #fff;">
                                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Grand Total with GST</td>
                                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur((projContractView[3].gst_tax_amt ? projContractView[3].gst_tax_amt : 0) + (projContractView[6].gst_tax_amt ? projContractView[6].gst_tax_amt : 0)) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                </tbody>
                              </table>
                            </v-flex>
                          </v-flex>
                        </v-flex>
                        <v-flex xs12 style="padding-top: 6px;" v-if="projContractView[28] && projContractView[28][0].total_amount">
                          <v-flex xs12 style="border: 1px solid black; border-radius: 0px;">
                            <div style="background-color: #4570d6; padding: 4px 0px; color: #fff; text-align: center; font-family: Arial, Helvetica, sans-serif;">SERVICE</div>
                            <v-data-table
                            :headers="techHeaders"
                            hide-default-header
                            disable-sort
                            :items="projContractView[0].concat(projContractView[9]).concat(projContractView[12]).concat(projContractView[15]).concat(projContractView[18]).concat(projContractView[21]).concat(projContractView[24])"
                            hide-default-footer
                            dense
                            disable-pagination>
                              <template v-slot:header="{ props: { headers } }">
                                <thead>
                                  <tr>
                                    <th style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 368px; text-align: left;">{{headers[0].text}}</th>
                                    <th style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: right;">{{headers[1].text}}</th>
                                    <th style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; text-align: left;">{{headers[2].text}}</th>
                                  </tr>
                                </thead>
                              </template>
                              <template slot="item" slot-scope="props">
                                <tr>
                                  <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.proj_contract_sub_category }}</td>
                                  <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: right; font-family: Arial, Helvetica, sans-serif;">{{ props.item.amount }}</td>
                                  <td style="border-bottom: 1px solid #bebebe; font-size: 12px; text-align: left; font-family: Arial, Helvetica, sans-serif;">{{ props.item.comments }}</td>
                                </tr>
                              </template>
                            </v-data-table>
                            <v-flex xs12>
                              <table width="100%" cellpadding="0" cellspacing="0">
                                <tbody>
                                  <tr style="color: #000;">
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">Sub Total</td>
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(projContractView[28][0].total_amount) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                  <tr style="color: #000;">
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">Management fees</td>
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(projContractView[28][0].mgmt_fee) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                  <tr style="background-color: #93f0cf; color:#09391f;">
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px; color:#09391f;">Total Before Tax</td>
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(projContractView[28][0].before_gst) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                  <tr style="color: #000;">
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; padding: 4px 16px; width: 368px;">GST</td>
                                    <td style="font-size: 12px; font-weight: bold; font-family: Arial, Helvetica, sans-serif; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(projContractView[28].tax_amt) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                  <tr style="background-color: #44cb82; color: #fff;">
                                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; padding: 4px 16px; width: 368px;">Grand Total with GST</td>
                                    <td style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; font-weight: bold; text-align: right; padding-right: 16px; width: 100px;">
                                      {{ handy.formatCur(projContractView[28][0].total_amt) }}
                                    </td>
                                    <td></td>
                                  </tr>
                                </tbody>
                              </table>
                            </v-flex>
                          </v-flex>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-card-text>
            <v-card-actions class="pt-0">
              <v-flex xs12>
                <v-tabs v-model="attTab" show-arrows>
                  <v-tab v-for="(attitem, n) in viewTabItems" :key="n" :href="`#tab-${n}`" @click="changeView(attitem)">
                    {{attitem}}
                  </v-tab>
                </v-tabs>
              </v-flex>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <!-- 11. "Deboarding Review View" for selected mi_base_id -->
        <v-dialog v-model="showDeboardingReviewView" persistent max-width="1200px" grid-list-md>
          <v-card>
            <v-card-title fixed class="py-0 grey lighten-2">
              <div style="font-size: 17px" class="font-weight-bold">Operation Review - Detailed View</div>
              <v-spacer></v-spacer>
              <v-btn icon @click="showDeboardingReviewView = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-text class="pt-3 pa-3">
              <v-card>
                <v-card-title style="background-color: #4570d6; color: #fff" class="py-2">
                  <div class="body-2 font-weight-bold">Deboarding Planner Details</div>
                </v-card-title>
                <v-card-text class="pa-2">
                  <v-card :class="i > 0 ? 'mt-2' : ''" v-for="(cat, i) in deboardCat" :key="i">
                    <v-card-title style="background-color: #71c1f5;" class="body-2 font-weight-bold py-1">
                      {{cat}}
                    </v-card-title>
                    <v-data-table
                    :headers="deboardPlannerReviewItemViewHeader"
                    :items="deboardPlannerReviewItemList.filter(rec => rec.deb_planner_cat === cat)"
                    hide-default-footer
                    hide-default-header
                    disable-pagination
                    dense
                    class="elevation-1"
                    :mobile-breakpoint="0">
                      <template v-slot:header="{ props: { headers } }">
                        <thead>
                          <tr>
                            <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 55px; text-align: center;">{{headers[0].text}}</th>
                            <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 275px; text-align: left;">{{headers[1].text}}</th>
                            <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 130px; text-align: left;">{{headers[2].text}}</th>
                            <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 120px; text-align: center;">{{headers[3].text}}</th>
                            <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 120px; text-align: center;">{{headers[4].text}}</th>
                            <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: center;">{{headers[5].text}}</th>
                            <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 120px; text-align: left;">{{headers[6].text}}</th>
                          </tr>
                        </thead>
                      </template>
                      <template slot="item" slot-scope="props">
                        <tr :class="(props.item.deb_status === 'Not Started' || props.item.deb_status === 'In-Progress' || props.item.deb_status === 'On-Hold') ? 'red--text' : ''" >
                          <td style="font-size: 12px;">{{ props.index + 1 }}</td>
                          <td style="font-size: 12px;">{{ props.item.deb_planner_sub_cat }}</td>
                          <td style="font-size: 12px;">{{ props.item.disp_short_name ? props.item.disp_short_name.replace(/,/g, ", ") : '-' }}</td>
                          <td style="font-size: 12px;" class="text-center">{{ props.item.deb_plan_end_dt ? handy.formatDate(props.item.deb_plan_end_dt) : '-' }}</td>
                          <td style="font-size: 12px;" class="text-center">{{ props.item.deb_actual_end_dt ? handy.formatDate(props.item.deb_actual_end_dt) : '-' }}</td>
                          <td style="font-size: 12px;">{{ props.item.deb_status }}</td>
                          <td style="font-size: 12px;">{{ props.item.deb_remarks ? props.item.deb_remarks : '-' }}</td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-card-text>
              </v-card>
              <v-card class="mt-2">
                <v-card-title style="background-color: #4570d6; color: #fff" class="py-2">
                  <div class="body-2 font-weight-bold">Asset Recovery Details</div>
                </v-card-title>
                <v-card-text class="pa-0">
                  <v-data-table
                  :headers="onbPlannerRecoverAssetItemViewHeader"
                  :items="onbPlannerRecoverAssetItemList"
                  hide-default-footer
                  hide-default-header
                  disable-pagination
                  dense
                  class="elevation-1"
                  :mobile-breakpoint="0">
                  <template v-slot:header="{ props: { headers } }">
                    <thead>
                      <tr>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 55px; text-align: left;">{{headers[0].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 175px; text-align: left;">{{headers[1].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 230px; text-align: left;">{{headers[2].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 120px; text-align: center;">{{headers[3].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 120px; text-align: center;">{{headers[4].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: center;">{{headers[5].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 120px; text-align: left;">{{headers[6].text}}</th>
                      </tr>
                    </thead>
                  </template>
                    <template slot="item" slot-scope="props">
                      <tr :class="(props.item.mi_is_asset_recovered === 'No') ? 'red--text' : ''">
                        <td style="font-size: 12px;">{{ props.index + 1 }}</td>
                        <td style="font-size: 12px;">{{ props.item.onb_planner_cat }}</td>
                        <td style="font-size: 12px;">{{ props.item.onb_planner_sub_cat }}</td>
                        <td style="font-size: 12px;" class="text-center">{{ props.item.mi_is_asset_recoverable ? 'Yes' : 'No' }}</td>
                        <td style="font-size: 12px;" class="text-center">{{ props.item.mi_is_asset_recovered ? 'Yes' : 'No' }}</td>
                        <td style="font-size: 12px;" class="text-center">{{ props.item.mi_asset_recovered_dt ? handy.formatDate(props.item.mi_asset_recovered_dt) : '-' }}</td>
                        <td style="font-size: 12px;">{{ props.item.mi_asset_rec_remarks }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
              <v-card class="mt-2">
                <v-card-title style="background-color: #4570d6; color: #fff" class="py-2">
                  <div class="body-2 font-weight-bold">Vendor Service Withdrawal Details</div>
                </v-card-title>
                <v-card-text class="pa-0">
                  <v-data-table
                  :headers="manpowerandServiceWithdrawalItemViewHeader"
                  :items="manpowerandServiceWithdrawalItemList"
                  hide-default-footer
                  hide-default-header
                  disable-pagination
                  dense
                  class="elevation-1"
                  :mobile-breakpoint="0">
                  <template v-slot:header="{ props: { headers } }">
                    <thead>
                      <tr>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 55px; text-align: left;">{{headers[0].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 150px; text-align: left;">{{headers[1].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 40px; text-align: center;">{{headers[2].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: center;">{{headers[3].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 150px; text-align: left;">{{headers[4].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 120px; text-align: center;">{{headers[5].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 120px; text-align: center;">{{headers[6].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 120px; text-align: center;">{{headers[7].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 120px; text-align: left;">{{headers[8].text}}</th>
                      </tr>
                    </thead>
                  </template>
                    <template slot="item" slot-scope="props">
                      <tr :class="(props.item.deb_status === 'Not Yet' || props.item.deb_status === 'In-Progress' || props.item.deb_status === 'On-Hold') ? 'red--text' : ''">
                        <td style="font-size: 12px;">{{ props.index + 1 }}</td>
                        <td style="font-size: 12px;">{{ props.item.role_name }}</td>
                        <td style="font-size: 12px;" class="text-center">{{ props.item.headcount }}</td>
                        <td style="font-size: 12px;" class="text-center">{{ props.item.ser_type }}</td>
                        <td style="font-size: 12px;">{{ props.item.vendorsupplier_name ? props.item.vendorsupplier_name : '-'  }}</td>
                        <td style="font-size: 12px;" class="text-center">{{ props.item.is_deb_informed ? 'Yes' : 'No' }}</td>
                        <td style="font-size: 12px;" class="text-center">{{ props.item.deb_informed_dt ? handy.formatDate(props.item.deb_informed_dt) : '-' }}</td>
                        <td style="font-size: 12px;" class="text-center">{{ props.item.deb_status }}</td>
                        <td style="font-size: 12px;">{{ props.item.deb_remarks ? props.item.deb_remarks : '-' }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
              <v-card class="mt-2">
                <v-card-title style="background-color: #4570d6; color: #fff" class="py-2">
                  <div class="body-2 font-weight-bold">Documents</div>
                </v-card-title>
                <v-card-text class="pa-0">
                  <v-data-table
                  :headers="docItemHeader"
                  :items="docItemList"
                  hide-default-footer
                  hide-default-header
                  disable-pagination
                  dense
                  class="elevation-1"
                  :mobile-breakpoint="0">
                  <template v-slot:header="{ props: { headers } }">
                    <thead>
                      <tr>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 55px; text-align: left;">{{headers[0].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 250px; text-align: left;">{{headers[1].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 170px; text-align: center;">{{headers[2].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: left;">{{headers[3].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: left;">{{headers[4].text}}</th>
                        <th class="teal lighten-4" style="font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 350px; text-align: left;">{{headers[5].text}}</th>
                      </tr>
                    </thead>
                  </template>
                    <template slot="item" slot-scope="props">
                      <tr>
                        <td style="font-size: 12px;">{{ props.index + 1 }}</td>
                        <td style="font-size: 12px;">{{ props.item.file_name }}</td>
                        <td style="text-align:center;"><a :href="handy.loadImg(props.item.file_url)" download style="text-decoration: none;">
                          <v-icon small class="info--text">mdi-download</v-icon>
                        </a></td>
                        <td style="font-size: 12px;">{{ props.item.mi_doc_type }}</td>
                        <td style="font-size: 12px;">{{ props.item.source }}</td>
                        <td style="font-size: 12px;">{{ props.item.mi_doc_remarks }}</td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- 12. Deboarding Planner Review Validation Summary -->
        <v-dialog v-model="showDebPlannerValidationSummary" persistent max-width="1200px" grid-list-md>
          <v-card>
            <v-card-title class="py-0 grey lighten-2">
              <div style="font-size: 17px" class="font-weight-bold">Deboarding Planner Validation Summary</div>
              <v-spacer></v-spacer>
              <v-btn icon @click="showDebPlannerValidationSummary = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-text class="pt-3 pa-3">
              <v-card>
                <v-card-title style="background-color: #4570d6; color: #fff" class="py-2">
                  <div class="body-2 font-weight-bold">Deboarding Planner Details</div>
                </v-card-title>
                <v-card-text class="pa-2">
                  <v-card :class="i > 0 ? 'mt-2' : ''" v-for="(cat, i) in deboardCat" :key="i">
                    <v-card-title style="background-color: #71c1f5;" class="body-2 font-weight-bold py-1">
                      {{cat}}
                    </v-card-title>
                    <v-data-table
                    :headers="deboardPlannerValidationSummaryHeader"
                    :items="deboardPlannerValidationStatusList.filter(rec => rec.deb_planner_cat === cat)"
                    hide-default-footer
                    hide-default-header
                    disable-pagination
                    dense
                    class="elevation-1"
                    :mobile-breakpoint="0">
                      <template v-slot:header="{ props: { headers } }">
                        <thead>
                          <tr>
                            <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 55px; text-align: center;">{{headers[0].text}}</th>
                            <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 300px; text-align: left;">{{headers[1].text}}</th>
                            <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 150px; text-align: left;">{{headers[2].text}}</th>
                            <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 120px; text-align: center;">{{headers[3].text}}</th>
                            <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 120px; text-align: center;">{{headers[4].text}}</th>
                            <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: left;">{{headers[5].text}}</th>
                            <th style="background-color: #cee6f5;font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: center;">{{headers[6].text}}</th>
                          </tr>
                        </thead>
                      </template>
                      <template slot="item" slot-scope="props">
                        <tr>
                          <td style="font-size: 12px;">{{ props.index + 1 }}</td>
                          <td style="font-size: 12px;">{{ props.item.deb_planner_sub_cat }}</td>
                          <td style="font-size: 12px;">{{ props.item.disp_short_name ? props.item.disp_short_name.replace(/,/g, ", ") : '-' }}</td>
                          <td style="font-size: 12px;" class="text-center">{{ props.item.deb_plan_end_dt ? handy.formatDate(props.item.deb_plan_end_dt) : '-' }}</td>
                          <td style="font-size: 12px;" class="text-center">{{ props.item.deb_actual_end_dt ? handy.formatDate(props.item.deb_actual_end_dt) : '-' }}</td>
                          <td style="font-size: 12px;">{{ props.item.deb_status }}</td>
                          <td style="text-align:center;">
                            <v-icon v-if="props.item.is_valid === 'Valid'" small class="success--text">mdi-check</v-icon>
                            <v-icon v-if="props.item.is_valid === 'Invalid'" small class="red--text">mdi-close</v-icon>
                          </td>
                        </tr>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-card-text>
              </v-card>
              <v-card class="mt-2">
                <v-card-title style="background-color: #4570d6; color: #fff" class="py-2">
                  <div class="body-2 font-weight-bold">Asset Recovery Details</div>
                </v-card-title>
                <v-card-text class="pa-0">
                  <v-data-table
                  :headers="onbAssetRecValidationSummaryHeader"
                  :items="debAssetRecValidationStatusList"
                  hide-default-footer
                  hide-default-header
                  disable-pagination
                  dense
                  class="elevation-1"
                  :mobile-breakpoint="0">
                    <template v-slot:header="{ props: { headers } }">
                      <thead>
                        <tr>
                          <th style="background-color: #cee6f5; font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 55px; text-align: left;">{{headers[0].text}}</th>
                          <th style="background-color: #cee6f5; font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 200px; text-align: left;">{{headers[1].text}}</th>
                          <th style="background-color: #cee6f5; font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 250px; text-align: left;">{{headers[2].text}}</th>
                          <th style="background-color: #cee6f5; font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 120px; text-align: center;">{{headers[3].text}}</th>
                          <th style="background-color: #cee6f5; font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 120px; text-align: center;">{{headers[4].text}}</th>
                          <th style="background-color: #cee6f5; font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: left;">{{headers[5].text}}</th>
                          <th style="background-color: #cee6f5; font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: center;">{{headers[6].text}}</th>
                        </tr>
                      </thead>
                    </template>
                    <template slot="item" slot-scope="props">
                      <tr>
                        <td style="font-size: 12px;">{{ props.index + 1 }}</td>
                        <td style="font-size: 12px;">{{ props.item.onb_planner_cat }}</td>
                        <td style="font-size: 12px;">{{ props.item.onb_planner_sub_cat }}</td>
                        <td style="font-size: 12px;" class="text-center">{{ props.item.mi_is_asset_recoverable ? 'Yes' : 'No' }}</td>
                        <td style="font-size: 12px;" class="text-center">{{ props.item.mi_is_asset_recovered ? 'Yes' : 'No' }}</td>
                        <td style="font-size: 12px;" class="text-center">{{ props.item.mi_asset_recovered_dt ? handy.formatDate(props.item.mi_asset_recovered_dt) : '-' }}</td>
                        <td style="text-align:center;">
                          <v-icon v-if="props.item.is_valid === 'Valid'" small class="success--text">mdi-check</v-icon>
                          <v-icon v-if="props.item.is_valid === 'Invalid'" small class="red--text">mdi-close</v-icon>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
              <v-card class="mt-2">
                <v-card-title style="background-color: #4570d6; color: #fff" class="py-2">
                  <div class="body-2 font-weight-bold">Vendor Service Withdrawal Details</div>
                </v-card-title>
                <v-card-text class="pa-0">
                  <v-data-table
                  :headers="mandepSerWDValidationSummaryHeader"
                  :items="debVendorWithdrawalValidationStatusList"
                  hide-default-footer
                  hide-default-header
                  disable-pagination
                  dense
                  class="elevation-1"
                  :mobile-breakpoint="0">
                    <template v-slot:header="{ props: { headers } }">
                      <thead>
                        <tr>
                          <th style="background-color: #cee6f5; font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 55px; text-align: left;">{{headers[0].text}}</th>
                          <th style="background-color: #cee6f5; font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 200px; text-align: left;">{{headers[1].text}}</th>
                          <th style="background-color: #cee6f5; font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: center;">{{headers[2].text}}</th>
                          <th style="background-color: #cee6f5; font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 150px; text-align: left;">{{headers[3].text}}</th>
                          <th style="background-color: #cee6f5; font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 120px; text-align: center;">{{headers[4].text}}</th>
                          <th style="background-color: #cee6f5; font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 120px; text-align: center;">{{headers[5].text}}</th>
                          <th style="background-color: #cee6f5; font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: center;">{{headers[6].text}}</th>
                          <th style="background-color: #cee6f5; font-size: 12px; font-family: Arial, Helvetica, sans-serif; width: 100px; text-align: center;">{{headers[7].text}}</th>
                        </tr>
                      </thead>
                    </template>
                    <template slot="item" slot-scope="props">
                      <tr>
                        <td style="font-size: 12px;">{{ props.index + 1 }}</td>
                        <td style="font-size: 12px;">{{ props.item.role_name }}</td>
                        <td style="font-size: 12px;" class="text-center">{{ props.item.ser_type }}</td>
                        <td style="font-size: 12px;">{{ props.item.vendorsupplier_name ? props.item.vendorsupplier_name : '-' }}</td>
                        <td style="font-size: 12px;" class="text-center">{{ props.item.is_deb_informed ? 'Yes' : 'No' }}</td>
                        <td style="font-size: 12px;" class="text-center">{{ props.item.deb_informed_dt ? handy.formatDate(props.item.deb_informed_dt) : '-' }}</td>
                        <td style="font-size: 12px;" class="text-center">{{ props.item.deb_status }}</td>
                        <td style="text-align:center;">
                          <v-icon v-if="props.item.is_valid === 'Valid'" small class="success--text">mdi-check</v-icon>
                          <v-icon v-if="props.item.is_valid === 'Invalid'" small class="red--text">mdi-close</v-icon>
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-card-text>
          </v-card>
        </v-dialog>

        <!-- 13. Add Deboard Review from Mi_base -->
        <v-dialog v-model="showAddDeboardProjectDialog" persistent max-width="700px" grid-list-md>
          <v-form ref="pDeboardForm" @submit.prevent="saveDeboardReviewMap(lDeboardReviewMap.action)">
            <v-card>
              <v-card-title class="py-2 grey lighten-4">
                {{ lDeboardReviewMap.action }} Deboard Project Review Mapping
              </v-card-title>
              <v-card-text class="pt-0 pb-2">
                <v-flex xs12>
                  <v-layout row wrap class="pa-1">
                    <v-flex xs4 class="pa-1">
                      <v-autocomplete
                      v-model="lDeboardReviewMap.comm_id"
                      :items="reviewCommList"
                      item-text="comm_name"
                      item-value="comm_id"
                      label="Community"
                      hide-details
                      dense
                      style="font-size: 12px"
                      :disabled="lDeboardReviewMap.action === 'update'"
                      @input="loadProjectBasedOnCommIdHasReview(lDeboardReviewMap)"
                      @change="clearProjCombobox()"
                      :rules="[rules.required]"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs4 class="pa-1">
                      <v-autocomplete
                      v-model="lDeboardReviewMap.proj_id"
                      :items="reviewProjList"
                      item-text="proj_name"
                      item-value="proj_id"
                      label="Project"
                      hide-details
                      dense
                      style="font-size: 12px"
                      :disabled="lDeboardReviewMap.action === 'update'"
                      @input="loadActiveReviewForSelectedProject(lDeboardReviewMap)"
                      :rules="[rules.required]"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs4 class="pa-1">
                      <v-autocomplete
                      v-model="lDeboardReviewMap.mi_base_id"
                      label="Sales Review Version"
                      :items="reviewBaseList"
                      item-text="version"
                      item-value="mi_base_id"
                      hide-details
                      style="font-size: 12px"
                      dense
                      :disabled="lDeboardReviewMap.action === 'update'"
                      :rules="[rules.required]"
                      >
                      </v-autocomplete>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-card-text>
              <v-card-actions class="pb-3">
                <v-spacer></v-spacer>
                <v-btn small @click="closeAddDeboardProjectDialog()">close</v-btn>
                <v-btn small class="accent" v-if="config.IS_EDITED_BY_USER" type="submit">save</v-btn>
              </v-card-actions>
            </v-card>
          </v-form>
        </v-dialog>

        <!-- snack bar for reporting -->
        <v-snackbar :color="sbarCol" v-model="sbar"
        :timeout="3000" multi-line><span class="mx-auto">{{ sbarMsg }}</span>
        </v-snackbar>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import config from '@/config/app-cfg'
import handy from '@/utils/handy'

export default {
  data () {
    return {
      // common
      sbarMsg: '',
      sbar: false,
      sbarCol: 'error',
      search: '',
      lAction: 'view',
      config: config,
      handy: handy,
      rules: handy.rules,
      panel: [0,1,2,3,4],
      // Summary Page Declarations
      isClosedProject: false,
      isShowOnlyPendingItems: true,
      deboardReviewProjList: [],
      lDeboardReviewSummaryList: [],
      deboardReviewSummaryListHeader: [
        { text: 'SNo.', value: '', class: 'uniformchipinfo white--text' },
        { text: 'Current Department', value: 'current_dept', class: 'uniformchipinfo white--text' },
        { text: 'Review Version No.', value: 'version_no', class: 'uniformchipinfo white--text' },
        { text: 'Project Contract Version', value: 'project_contract_version', class: 'uniformchipinfo white--text' },
        { text: 'Project Contract Value', value: 'contract_amt_with_tax', class: 'uniformchipinfo white--text' }
      ],
      responsibilityEmpList: [],
      selTab: 0,
      beingSaved: false,
      lDebPlanner: [],
      source_var: 'Deboarding',
      status_list: ['Not Started', 'In-Progress', 'On-Hold', 'Completed', 'Not Applicable', 'Cancelled'],
      asset_recovery_status_list: ['No', 'Yes', 'Sold', 'Lost', 'NA'],
      mandep_ser_withdraw_status_list: ['Not Yet', 'Informed', 'Not Applicable'],
      doc_type_list: ['Agreement', 'LOI', 'Salary-Breakup', 'Audit-Report', 'Checklist', 'MoM', 'MC e-Mail', 'Proposal/ Quote', 'Project Exit Docs', 'Other'],
      viewTabItems: ['Proposal breakup', 'end-to-end proposal', 'compressed view', 'M&S view'],
      attTab: 'tab-0',
      categoryListForContractView: ['MANAGEMENT/OFFICE', 'TECHNICAL SERVICES', 'SOFT SERVICES', 'OTHERS'],
      // Deboard Review Planner Declarations
      lDeboardReviewBase: [],
      lVersion: null,
      commList: [],
      projList: [],
      projContractList: [],
      dlgDate: false,
      dlgExitDate: false,
      disableSubmitButton: false,
      deboardCat: [],
      deboardPlannerReviewItemHeader: [
        { text: 'SNo.', value: '', class: 'pr-0 grey lighten-4 primary--text', align: 'left', width: '55px', sortable: false },
        { text: 'Description', value: 'deb_planner_sub_cat', class: 'grey lighten-4 primary--text', width: '275px', sortable: false },
        { text: 'Responsibility', value: 'disp_short_name', class: 'grey lighten-4 primary--text', width: '140px', sortable: false },
        { text: 'Plan End Date', value: 'deb_plan_end_dt', class: 'grey lighten-4 primary--text', width: '120px', align: 'center', sortable: false },
        { text: 'Act End Date', value: 'deb_actual_end_dt', class: 'grey lighten-4 primary--text', width: '120px', align: 'center', sortable: false },
        { text: 'Status', value: 'deb_status', class: 'grey lighten-4 primary--text', width: '120px', sortable: false },
        { text: 'Remark', value: 'deb_remarks', class: 'grey lighten-4 primary--text', width: '200px', sortable: false }
      ],
      deboardPlannerReviewItemViewHeader: [
        { text: 'SNo.', value: '', class: 'pr-0 grey lighten-4 primary--text', align: 'left', width: '55px', sortable: false },
        { text: 'Description', value: 'deb_planner_sub_cat', class: 'grey lighten-4 primary--text', width: '275px', sortable: false },
        { text: 'Responsibility', value: 'disp_short_name', class: 'grey lighten-4 primary--text', width: '140px', sortable: false },
        { text: 'Plan End Date', value: 'deb_plan_end_dt', class: 'grey lighten-4 primary--text', width: '120px', align: 'center', sortable: false },
        { text: 'Act End Date', value: 'deb_actual_end_dt', class: 'grey lighten-4 primary--text', width: '120px', align: 'center', sortable: false },
        { text: 'Status', value: 'deb_status', class: 'grey lighten-4 primary--text', width: '120px', sortable: false },
        { text: 'Remark', value: 'deb_remarks', class: 'grey lighten-4 primary--text', width: '200px', sortable: false }
      ],
      deboardPlannerReviewItemList: [],
      docItemHeader:[
        { text: 'Sno', value: 'sno' },
        { text: 'Document File Name', value: 'mi_sales_sub_cat' },
        { text: 'Download', value: '', sortable: false },
        { text: 'Doc Type', value: 'mi_doc_type', sortable: false },
        { text: 'Source', value: 'source', sortable: false },
        { text: 'Remark', value: 'sales_review_doc_remarks' }
      ],
      docItemList: [],
      showCommunityInfo: false,
      commBasicInformationList: [],
      showProjectInfo: false,
      projBasicInformationList: [],
      showProjectContractInfo: false,
      projContractInformationList: [],
      showContractViewAsPdf: false,
      techHeaders: [
        { text: 'Category' , value: 'proj_contract_sub_category' },
        { text: 'Total' , value: 'amount', sortable: false },
        { text: 'Comments' , value: 'comments', sortable: false }
      ],
      manpowerHeaders: [
        { text: 'Category' , value: 'staff_role' },
        { text: 'No of Person' , value: 'head_count' },
        { text: 'Rate/Person' , value: 'amt_per_hc' },
        { text: 'Total' , value: 'total_hc_amt' },
        { text: 'Comments' , value: 'comments' }
      ],
      projContractView: [],
      showDebPlanner: false,
      planEndDt: false,
      actualEndDt: false,
      selected: [],
      showListOfDeboardingPlannerDet: false,
      deboardingPlannerDetHeadList: [
        { text: 'Category', value: 'mi_deboard_cat', class: 'primary--text', sortable: false },
        { text: 'Task Description', value: 'mi_deboard_sub_cat', class: 'primary--text', sortable: false },
        { text: 'Days Prior', value: 'prior_days', class: 'primary--text', width: '100px', align: 'center', sortable: false  },
        { text: 'Exit Date', value: 'proj_exit_date', class: 'primary--text', width: '120px', align: 'center', sortable: false  },
        { text: 'Plan End Date', value: 'plan_end_date', class: 'primary--text', width: '120px', align: 'center', sortable: false  }
      ],
      deboardingPlannerDetList: [],
      showDeboardingDocUpload: false,
      lUploadDoc: [],
      showDeboardingReviewView: false,
      showDebPlannerValidationSummary: false,
      isDebReviewValid: false,
      deboardPlannerValidationStatusList: [],
      debAssetRecValidationStatusList: [],
      debVendorWithdrawalValidationStatusList: [],
      deboardPlannerValidationSummaryHeader: [
        { text: 'SNo.', value: '', class: 'pr-0 grey lighten-4 primary--text', align: 'left', width: '55px', sortable: false },
        { text: 'Description', value: 'deb_planner_sub_cat', class: 'grey lighten-4 primary--text', width: '275px', sortable: false },
        { text: 'Responsibility', value: 'disp_short_name', class: 'grey lighten-4 primary--text', width: '140px', sortable: false },
        { text: 'Plan End Date', value: 'deb_plan_end_dt', class: 'grey lighten-4 primary--text', width: '120px', align: 'center', sortable: false },
        { text: 'Act End Date', value: 'deb_actual_end_dt', class: 'grey lighten-4 primary--text', width: '120px', align: 'center', sortable: false },
        { text: 'Status', value: 'deb_status', class: 'grey lighten-4 primary--text', width: '120px', sortable: false },
        { text: 'Is Valid?', value: '', class: 'grey lighten-4 primary--text', width: '100px', sortable: false }
      ],
      // Recoverable Asset Declarations
      onbPlannerRecoverAssetItemList: [],
      onbPlannerRecoverAssetItemHeader: [
        { text: 'SNo.', value: '', class: 'pr-0 grey lighten-4 primary--text', align: 'left', width: '55px', sortable: false },
        { text: 'Category', value: 'onb_planner_cat', class: 'grey lighten-4 primary--text', width: '200px', sortable: false },
        { text: 'Description', value: 'onb_planner_sub_cat', class: 'grey lighten-4 primary--text', width: '200px', sortable: false },
        { text: 'Recoverable?', value: 'mi_is_asset_recoverable', class: 'grey lighten-4 primary--text', width: '120px', align: 'center', sortable: false },
        { text: 'Is Recovered?', value: 'mi_is_asset_recovered', class: 'grey lighten-4 primary--text', width: '120px', align: 'center', sortable: false },
        { text: 'Recovered Date', value: 'mi_asset_recovered_dt', class: 'grey lighten-4 primary--text', width: '120px', align: 'center', sortable: false },
        { text: 'Remark', value: 'mi_asset_rec_remarks', class: 'grey lighten-4 primary--text', width: '200px', sortable: false }
      ],
      onbPlannerRecoverAssetItemViewHeader: [
        { text: 'SNo.', value: '', class: 'pr-0 grey lighten-4 primary--text', sortable: false },
        { text: 'Category', value: 'onb_planner_cat', class: 'grey lighten-4 primary--text', sortable: false },
        { text: 'Description', value: 'onb_planner_sub_cat', class: 'grey lighten-4 primary--text', sortable: false },
        { text: 'Recoverable?', value: 'mi_is_asset_recoverable', class: 'grey lighten-4 primary--text', sortable: false },
        { text: 'Is Recovered?', value: 'mi_is_asset_recovered', class: 'grey lighten-4 primary--text', sortable: false },
        { text: 'Recovered Date', value: 'mi_asset_recovered_dt', class: 'grey lighten-4 primary--text', sortable: false },
        { text: 'Remark', value: 'mi_asset_rec_remarks', class: 'grey lighten-4 primary--text', sortable: false }
      ],
      onbAssetRecValidationSummaryHeader: [
        { text: 'SNo.', value: '', class: 'pr-0 grey lighten-4 primary--text', sortable: false },
        { text: 'Category', value: 'onb_planner_cat', class: 'grey lighten-4 primary--text', sortable: false },
        { text: 'Description', value: 'onb_planner_sub_cat', class: 'grey lighten-4 primary--text', sortable: false },
        { text: 'Recoverable?', value: 'mi_is_asset_recoverable', class: 'grey lighten-4 primary--text', sortable: false },
        { text: 'Is Recovered?', value: 'mi_is_asset_recovered', class: 'grey lighten-4 primary--text', sortable: false },
        { text: 'Recover Date', value: 'mi_asset_recovered_dt', class: 'grey lighten-4 primary--text', sortable: false },
        { text: 'Is Valid?', value: '', class: 'grey lighten-4 primary--text', width: '100px', sortable: false }
      ],
      lOnbPlannerAssetRecovery: [],
      showOnbPlannerAssetRecovery: false,
      assetRecoveryDt: false,
      showContractImportSection: false,
      approvedContractList: [],
      // Outsourced Manpower and Other Services Withdrawal Declarations
      lManpowerandServiceWithdrawalItemList: [],
      showManpowerandServiceWithdrawal: false,
      mandepSerWithdrawalDt: false,
      manpowerandServiceWithdrawalItemList: [],
      manpowerandServiceWithdrawalItemHeader: [
        { text: 'SNo.', value: '', class: 'pr-0 grey lighten-4 primary--text', align: 'left', width: '55px', sortable: false },
        { text: 'Role Name/ Service', value: 'role_name', class: 'grey lighten-4 primary--text', width: '200px', sortable: false },
        { text: 'Head Count', value: 'headcount', class: 'grey lighten-4 primary--text', width: '100px', sortable: false },
        { text: 'Service Type', value: 'ser_type', class: 'grey lighten-4 primary--text', width: '120px', align: 'center', sortable: false },
        { text: 'Vendor Name', value: 'vendorsupplier_name', class: 'grey lighten-4 primary--text', width: '200px', sortable: false },
        { text: 'Info to Vendor?', value: 'is_deb_informed', class: 'grey lighten-4 primary--text', width: '120px', align: 'center', sortable: false },
        { text: 'Informed Date', value: 'deb_informed_dt', class: 'grey lighten-4 primary--text', width: '120px', align: 'center', sortable: false },
        { text: 'Status', value: 'deb_status', class: 'grey lighten-4 primary--text', width: '120px', align: 'center', sortable: false },
        { text: 'Remark', value: 'deb_remarks', class: 'grey lighten-4 primary--text', width: '250px', sortable: false }
      ],
      manpowerandServiceWithdrawalItemViewHeader: [
        { text: 'SNo.', value: '', class: 'pr-0 grey lighten-4 primary--text', sortable: false },
        { text: 'Role Name/ Service', value: 'role_name', class: 'grey lighten-4 primary--text', sortable: false },
        { text: 'HC', value: 'headcount', class: 'grey lighten-4 primary--text', sortable: false },
        { text: 'Ser.Type', value: 'ser_type', class: 'grey lighten-4 primary--text', sortable: false },
        { text: 'Vendor Name', value: 'vendorsupplier_name', class: 'grey lighten-4 primary--text', sortable: false },
        { text: 'Info to Vendor?', value: 'is_deb_informed', class: 'grey lighten-4 primary--text', sortable: false },
        { text: 'Informed Date', value: 'deb_informed_dt', class: 'grey lighten-4 primary--text', sortable: false },
        { text: 'Status', value: 'deb_status', class: 'grey lighten-4 primary--text', sortable: false },
        { text: 'Remark', value: 'deb_remarks', class: 'grey lighten-4 primary--text', sortable: false }
      ],
      mandepSerWDValidationSummaryHeader: [
        { text: 'SNo.', value: '', class: 'pr-0 grey lighten-4 primary--text', sortable: false },
        { text: 'Role Name/ Service', value: 'role_name', class: 'grey lighten-4 primary--text', sortable: false },
        { text: 'Ser.Type', value: 'ser_type', class: 'grey lighten-4 primary--text', sortable: false },
        { text: 'Vendor Name', value: 'vendorsupplier_name', class: 'grey lighten-4 primary--text', sortable: false },
        { text: 'Info to Vendor?', value: 'is_deb_informed', class: 'grey lighten-4 primary--text', sortable: false },
        { text: 'Informed Date', value: 'deb_informed_dt', class: 'grey lighten-4 primary--text', sortable: false },
        { text: 'Status', value: 'deb_status', class: 'grey lighten-4 primary--text', sortable: false },
        { text: 'Is Valid?', value: '', class: 'grey lighten-4 primary--text', width: '100px', sortable: false }
      ],
      tempContractList: [],
      lDeboardReviewMap: [],
      showAddDeboardProjectDialog: false,
      reviewCommList: [],
      reviewProjList: [],
      reviewBaseList: [],
    }
  },
  created () {
    this.loadDebaordReviewSummaryList()
    this.loadResponsibiltyEmpList()
    this.isShowOnlyPendingItems = false
  },
  methods: {
    msg (m, type = 0) {
      if (type === 0) {
        this.sbarCol = 'error'
      } else if (type === 1) {
        this.sbarCol = 'success'
      } else {
        this.sbarCol = 'info'
      }
      this.sbar = true
      this.sbarMsg = m
    },
    searchProjectTitle (curRec) {
      if (curRec && curRec.length > 1) {
        var tmpVar = this.deboardReviewProjList.filter(rec => rec.toLowerCase().includes(curRec.toLowerCase()))
        if (tmpVar.length > 0) {
          this.deboardReviewProjList = []
          this.deboardReviewProjList = tmpVar
        } else {
          this.deboardReviewProjList = []
        }
      } else {
        this.loadDebaordReviewSummaryList()
      }
    },
    showClosedProjects () {
      this.isClosedProject = !this.isClosedProject
      this.loadDebaordReviewSummaryList()
    },
    loadOnlyPendingItems () {
      this.isShowOnlyPendingItems = !this.isShowOnlyPendingItems
      this.loadDeboardingReviewDetails()
    },
    loadDebaordReviewSummaryList () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
          is_closed_project: this.isClosedProject
        }
      }
      this.lDeboardReviewSummaryList = []
      this.axios.get(config.API_URL + '/getListOfDeboardReviewSummaryBaseByVendorId/', qry)
      .then(response => {
        this.lDeboardReviewSummaryList = response.data
        this.deboardReviewProjList = handy.unique(this.lDeboardReviewSummaryList.map(rec => rec.proj_name))
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadResponsibiltyEmpList () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getMIAllResponseList/', qry)
      .then(response => {
        this.responsibilityEmpList = response.data.filter(rec =>rec.mi_status === "Active")
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareUpdate (curRec) {
      this.showContractImportSection = false
      this.lDeboardReviewBase = Object.assign({}, curRec)
      this.loadCommunity()
      this.loadReviewVersionBasedonMIBaseId()
      this.lDeboardReviewBase.comm_pair = { comm_id: curRec.comm_id, comm_name: curRec.comm_name }
      this.lDeboardReviewBase.proj_pair = { proj_id: curRec.proj_id, proj_name: curRec.proj_name }
      this.lVersion = this.lDeboardReviewBase.mi_base_id
      this.lDeboardReviewBase.new_proj_contract_base_id = null
      this.lDeboardReviewBase.on_boarding_date = curRec.on_boarding_date ? handy.formatDBDate(curRec.on_boarding_date) : ''
      this.lDeboardReviewBase.proj_exit_date = curRec.proj_exit_date ? handy.formatDBDate(curRec.proj_exit_date) : ''
      this.loadProjectBasedOnCommId (this.lDeboardReviewBase)
      this.loadProjectContractBasedOnMIBaseID (this.lDeboardReviewBase)
      setTimeout(() => {
        this.showNewApprovedContractDetailsImportSection()
      }, 500)
      this.loadDeboardingReviewDetails()
      this.lAction = 'update'
    },
    loadCommunity () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.commList = []
      this.projList = []
      this.axios.get(config.API_URL + '/getProjectCommList/', qry)
      .then(response => {
        this.commList = response.data
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadProjectBasedOnCommId (curComm) {
      if (curComm.comm_pair && curComm.comm_pair.comm_id) {
        var qry = {
          params: {
            comm_id: curComm.comm_pair.comm_id
          }
        }
        this.projList = []
        this.axios.get(config.API_URL + '/getProjectListBasedOnCommId/', qry)
        .then(response => {
          this.projList = response.data
          this.$forceUpdate()
        })
        .catch(err => {
          this.msg(err, 0)
        })
      }
    },
    loadProjectContractBasedOnMIBaseID (curReview) {
      if (curReview.proj_pair && curReview.proj_pair.proj_id) {
        var qry = {
          params: {
            proj_id: curReview.proj_pair.proj_id,
            mi_base_id: curReview.mi_base_id,
            vendor_id: config.VENDOR_ID
          }
        }
        this.projContractList = []
        this.axios.get(config.API_URL + '/getProjectContractBasedOnProjId/', qry)
        .then(response => {
          this.projContractList = response.data
          this.$forceUpdate()
        })
        .catch(err => {
          this.msg(err, 0)
        })
      }
    },
    loadReviewVersionBasedonMIBaseId () {
      var qry = {
        params: {
          mi_base_id: this.lDeboardReviewBase.mi_base_id,
          vendor_id: config.VENDOR_ID
        }
      }
      this.versionList = []
      this.axios.get(config.API_URL + '/getReviewVersionBasedonMIBaseId/', qry)
      .then(response => {
        this.versionList = response.data
        this.versionList.forEach(rec => {
          if (rec.mi_base_id === this.lDeboardReviewBase.mi_base_id) {
            // disable submit to all action buttons if the status is closed
            if (rec.version.includes('Closed')) {
              this.disableSubmitButton = true
            } else {
              this.disableSubmitButton = false
            }
          }
        })
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadDeboardingReviewDetails () {
      var path = require('path')
      this.loadReviewVersionBasedonMIBaseId()
      var qry = {
        params: {
          mi_base_id: this.lDeboardReviewBase.mi_base_id,
          proj_contract_base_id: this.lDeboardReviewBase.proj_contract_base_id,
          showOnlyPendingItems: this.isShowOnlyPendingItems,
          vendor_id: config.VENDOR_ID
        }
      }
      this.loadDeboardingPlannerReviewItemList()
      this.loadManpowerandServiceDetforWithdrawalItemList()
      this.loadOnbPlannerAssetRecoveryItemList()

      this.docItemList = []
      this.axios.get(config.API_URL + '/getListOfOnbReviewDocUploadsBasedonMIBaseId/', qry)
      .then(response => {
        response.data.forEach((rec) => {
          this.docItemList.push({
            file_url: rec.file_url,
            file_name: rec.file_url ? path.basename(rec.file_url) : '',
            is_selected: true,
            is_changed: false,
            mi_doc_type: rec.mi_doc_type,
            source: rec.source,
            mi_doc_remarks: rec.mi_doc_remarks,
            mi_doc_upload_id: rec.mi_doc_upload_id,
            mi_base_id: this.lDeboardReviewBase.mi_base_id
          })
        })
      })
    },
    showNewApprovedContractDetailsImportSection () {
      var qry = {
        params: {
          mi_base_id: this.lDeboardReviewBase.mi_base_id,
          vendor_id: config.VENDOR_ID
        }
      }
      this.showContractImportSection = false
      if (this.lDeboardReviewBase.base_status === 'Sales') {
        // verify mi_base_id's current proj_contract_base_id status is approved, if it is approved, importsection is false or true
        this.axios.get(config.API_URL + '/getMiProjectContractVersionStatusForMiBaseId/', qry)
        .then(response => {
          if(response.data[0].status === 'Approved') {
            this.showContractImportSection = false
          } else {
            this.showContractImportSection = true
          }
        })
        .catch(err => {
          this.msg(err, 0)
        })
      } else {
        this.axios.get(config.API_URL + '/getMiProjectContractMappingDetailsForMiBaseId/', qry)
        .then(response => {
          // get temp list
          var tmpContList = []
          var temp_proj_contract_base_id = this.projContractList[0].proj_contract_base_id
          this.tmpContList = response.data.filter(rec => rec.proj_contract_base_id === this.projContractList[0].proj_contract_base_id)
          if (this.tmpContList.length === 0 && this.lDeboardReviewBase.current_dept != 'Closed') {
            this.showContractImportSection = true
          } else {
            this.showContractImportSection = false
          }
        })
        .catch(err => {
          this.msg(err, 0)
        })
      }
    },
    saveDeboardReviewBaseChanges (action) {
      if (this.lDeboardReviewBase.proj_exit_date && this.lDeboardReviewBase.deboard_remarks) {
        this.axios.post(config.API_URL + '/miSaveDeboardReviewBase/base-update', this.lDeboardReviewBase)
        .then(response => {
          this.msg('Saved Successfully', 1)
        })
        .catch(err => {
          this.msg(err, 0)
        })
      } else {
        this.msg('Please Select Project Exit Date and Reason for Project Closure', 0)
      }
    },
    showBasicInformationOfCommunity (curDeboardReviewBase) {
      if (curDeboardReviewBase.comm_pair && curDeboardReviewBase.comm_pair.comm_id) {
        var qry = {
          params: {
            comm_id: curDeboardReviewBase.comm_pair.comm_id
          }
        }
        this.commBasicInformationList = []
        this.axios.get(config.API_URL + '/getBasicInformationofCommunity/', qry)
        .then(response => {
          this.commBasicInformationList = response.data
          this.showCommunityInfo = true
        })
        .catch(err => {
          this.msg(err, 0)
        })
      }
    },
    showBasicInformationOfProject (curDeboardReviewBase) {
      if (curDeboardReviewBase.proj_pair && curDeboardReviewBase.proj_pair.proj_id) {
        var qry = {
          params: {
            proj_id: curDeboardReviewBase.proj_pair.proj_id
          }
        }
        this.projBasicInformationList = []
        this.axios.get(config.API_URL + '/getBasicInformationofProject/', qry)
        .then(response => {
          this.projBasicInformationList = response.data
          this.showProjectInfo = true
        })
        .catch(err => {
          this.msg(err, 0)
        })
      }
    },
    showBasicInformationOfProjectContract (curDeboardReviewBase) {
      if (curDeboardReviewBase.proj_contract_base_id) {
        var qry = {
          params: {
            proj_contract_base_id: curDeboardReviewBase.proj_contract_base_id
          }
        }
        this.projContractInformationList = []
        this.axios.get(config.API_URL + '/getBasicInformationofProjectContract/', qry)
        .then(response => {
          this.projContractInformationList = response.data
          this.showProjectContractInfo = true
        })
        .catch(err => {
          this.msg(err, 0)
        })
      }
    },
    changeView (curTab) {
      if (curTab === 'Proposal breakup') {
        this.attTab = 'tab-0'
      } else if (curTab === 'end-to-end proposal') {
        this.attTab = 'tab-1'
      } else if (curTab === 'compressed view') {
        this.attTab = 'tab-2'
      } else {
        this.attTab = 'tab-3'
      }
    },
    prepareViewProjContract (curContract) {
      var qry = {
        params: {
          proj_contract_base_id: curContract.proj_contract_base_id
        }
      }
      this.axios.get(config.API_URL + '/getProjContractViewAsPdf/', qry)
      .then(response => {
        this.projContractView = response.data
        this.projContractView.forEach(rec => {
          if (rec.length) {
            if (!rec.total_amount) {
              rec.total_amount = 0
            }
            if (!rec.gst_amt || !rec.before_gst) {
              rec.gst_tax_amt = 0
              rec.tax_amt = 0
              rec.before_gst = 0
            }
            if (!rec.mgmt) {
              rec.mgmt = 0
            }
            rec.forEach(records => {
              if (records.amount) {
                rec.total_amount += records.amount
              }
              if (records.total_hc_amt) {
                rec.total_amount += records.total_hc_amt
              }
              rec.mgmt += records.Mgmt_fee_amt
              rec.tax_amt += records.tax_amt
              rec.before_gst = rec.total_amount + rec.mgmt
              rec.gst_tax_amt = rec.before_gst + rec.tax_amt
            })
          }
        })
        this.showContractViewAsPdf = true
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    prepareCreateDeboardingPlanner () {
      this.lDebPlanner = {
        deb_planner_cat: '',
        deb_planner_sub_cat: '',
        deb_remarks: '',
        deb_source: 'Deboarding',
        deb_status: 'Not Started',
        mi_base_id: this.lDeboardReviewBase.mi_base_id,
        deb_responsible_pair_id: [],
        action: 'create'
      }
      this.showDebPlanner = true
    },
    prepareDebPlannerUpdate (curRec) {
      if (curRec.emp_id) {
        curRec.deb_responsible_pair_id = []
        curRec.emp_id.split(",").forEach(rec => {
          curRec.deb_responsible_pair_id.push(parseInt(rec))
        })
      }
      this.lDebPlanner = Object.assign({}, curRec)
      this.lDebPlanner.deb_plan_end_dt = this.lDebPlanner.deb_plan_end_dt ? handy.formatDBDate(this.lDebPlanner.deb_plan_end_dt) : null
      this.lDebPlanner.deb_actual_end_dt = this.lDebPlanner.deb_actual_end_dt ? handy.formatDBDate(this.lDebPlanner.deb_actual_end_dt) : null
      this.lDebPlanner.action = 'update'
      this.loadResponsibiltyEmpList()
      this.loadDeboardingReviewDetails()
      this.showDebPlanner = true
    },
    loadDeboardingPlannerReviewItemList() {
      var qry = {
        params: {
          mi_base_id: this.lDeboardReviewBase.mi_base_id,
          proj_contract_base_id: this.lDeboardReviewBase.proj_contract_base_id,
          showOnlyPendingItems: this.isShowOnlyPendingItems,
          vendor_id: config.VENDOR_ID
        }
      }
      this.deboardPlannerReviewItemList = []
      this.axios.get(config.API_URL + '/getListOfDeboardingPlannerDetailsBasedonMIBaseId/', qry)
      .then(response => {
        this.deboardPlannerReviewItemList = response.data
        this.deboardCat = handy.unique(this.deboardPlannerReviewItemList.map(rec => rec.deb_planner_cat))
      })
    },
    saveDeboardingPlannerChanges () {
      if (this.lDebPlanner.deb_planner_cat && this.lDebPlanner.deb_planner_sub_cat) {
        this.lDebPlanner.vendor_id = config.VENDOR_ID
        this.lDebPlanner.deb_responsible = this.lDebPlanner.deb_responsible_pair_id ? this.lDebPlanner.deb_responsible_pair_id.map(rec => rec.emp_id) : null
        this.axios.post(config.API_URL + '/miDeboardingPlannerDet/', this.lDebPlanner)
        .then(response => {
          this.loadDeboardingReviewDetails()
          this.msg('Saved Successfully', 1)
          this.showDebPlanner = false
        })
        .catch(err => {
          this.msg(err, 0)
        })
      } else {
        this.msg('Please enter all mandatory fields', 0)
      }
    },
    prepareDeboardingPlannerImport (filterList) {
      var qry = {
        params: {
          mi_base_id: this.lDeboardReviewBase.mi_base_id,
          vendor_id: config.VENDOR_ID,
          filter: filterList.length > 0 ? filterList.map(rec => rec.deb_planner_sub_cat_id) : null
        }
      }
      this.deboardingPlannerDetList = []
      this.axios.get(config.API_URL + '/getMIProjectExitDateBaseonMiBaseIdVendorId/', qry)
      .then(response => {
        if(response.data.length > 0 && response.data[0].proj_exit_date != '') {
          this.axios.get(config.API_URL + '/getListOfDeboardPlannerBasedOnGivenBaseIdExceptAlreadyImported/', qry)
          .then(response => {
            this.deboardingPlannerDetList = response.data
            this.deboardingPlannerDetList.forEach(rec => {
              rec.proj_exit_date = rec.proj_exit_date ? handy.formatDate(rec.proj_exit_date) : '-'
              rec.plan_end_date = rec.plan_end_date ? handy.formatDate(rec.plan_end_date) : '-'
            })
            this.selected = []
            this.showListOfDeboardingPlannerDet = true
          })
          .catch(err => {
            this.msg(err, 0)
          })
        } else {
          this.msg('Please enter exit date and save', 0)
        }
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    importToDeboardingPlanner (curSelectedArray) {
      if (curSelectedArray.length > 0) {
        curSelectedArray.forEach(rec => {
          let date = new Date(handy.formatDBDate(this.lDeboardReviewBase.proj_exit_date))
          rec.deb_plan_end_dt = handy.formatDBDate(date.setDate(date.getDate() - rec.prior_days))
        })
        curSelectedArray.push({
          mi_base_id: this.lDeboardReviewBase.mi_base_id,
          vendor_id: config.VENDOR_ID,
          source: this.source_var // Deboarding
        })
        this.beingSaved = true
        this.axios.post(config.API_URL + '/miDeboardingPlannerDetailsImport/', curSelectedArray)
        .then(response => {
          if (response.data === 'success') {
            this.msg('Imported Successfully', 1)
          } else {
            this.msg(response.data, 0)
          }
          this.showListOfDeboardingPlannerDet = false
          this.beingSaved = false
          setTimeout(() => {
            this.loadDeboardingReviewDetails()
          }, 500)
        })
        .catch(err => {
          this.msg(err.response.data, 0)
        })
      } else {
        this.msg('Please select item from the list to import.', 0)
      }
    },
    prepareUploadDocs () {
      this.lUploadDoc = {
        mi_base_id: this.lDeboardReviewBase.mi_base_id,
        source: this.source_var, // Deboarding
        mi_doc_remarks: '',
        files: []
      }
      this.showDeboardingDocUpload = true
    },
    pickFile () {
      this.$refs.fileInput.click()
    },
    loadFilesFromFileBrowser (curProject) {
      curProject.source = this.source_var // "Deboarding"
      let currentDate = new Date()
      let time = currentDate.getHours() + "-" + currentDate.getMinutes() + "-" + currentDate.getSeconds()
      const files = event.target.files
      if (!curProject.files) {
        curProject.files = []
      }
      Array.from(files).forEach((file) => {
        const fileReader = new FileReader()
        const getResult = new Promise(resolve => {
          fileReader.onload = e => {
            curProject.files.push({
              file_url: e.target.result.split(',')[1],
              file_name: file.name.split('.')[0] + '_' + handy.formatDBDate(currentDate) + '_' + time + '.' + file.name.split('.')[1],
              is_selected: true,
              is_changed: true
            })
            this.$forceUpdate()
          }
        })
        fileReader.readAsDataURL(file)
        return getResult.then(file => {
          return file
        })
      })
      this.$refs.fileInput.value = ''
    },
    removeSelectedFile (curFile) {
      curFile.is_selected = false
      this.$forceUpdate()
    },
    saveUploadedDocs () {
      if (this.lUploadDoc.files && this.lUploadDoc.files.length > 0  && this.lUploadDoc.mi_doc_type ) {
        this.axios.post(config.API_URL + '/miReviewDocumentAttach/', this.lUploadDoc)
        .then(response => {
          this.msg('Saved Successfully', 1)
          this.showDeboardingDocUpload = false
          this.loadDeboardingReviewDetails()
          this.$forceUpdate()
        })
        .catch(err => {
          this.msg(err, 0)
        })
      } else {
        this.msg('Please select file, document type and remarks.', 0)
      }
    },
    updateDocItems (curRec) {
      this.lUploadDoc = Object.assign({}, curRec)
      if (!this.lUploadDoc.files) {
        this.lUploadDoc.files = []
      }
      this.lUploadDoc.files.push({
        is_selected: curRec.is_selected,
        is_changed: curRec.is_changed,
        file_name: curRec.file_name
      })
      this.showDeboardingDocUpload = true
    },
    loadManpowerandServiceDetforWithdrawalItemList () {
      var qry = {
        params: {
          mi_base_id: this.lDeboardReviewBase.mi_base_id,
          proj_contract_base_id: this.lDeboardReviewBase.proj_contract_base_id,
          showOnlyPendingItems: this.isShowOnlyPendingItems,
          vendor_id: config.VENDOR_ID
        }
      }
      this.manpowerandServiceWithdrawalItemList = []
      this.axios.get(config.API_URL + '/getMiOutsourcedMandepandServiceforWithdrawal/', qry)
      .then(response => {
        this.manpowerandServiceWithdrawalItemList = response.data
      })
    },
    prepareManpowerandServiceWithdrawalUpdate (curRec) {
      this.lManpowerandServiceWithdrawalItemList = Object.assign({}, curRec)
      this.lManpowerandServiceWithdrawalItemList.deb_informed_dt = this.lManpowerandServiceWithdrawalItemList.deb_informed_dt ? handy.formatDBDate(this.lManpowerandServiceWithdrawalItemList.deb_informed_dt) : null
      this.lManpowerandServiceWithdrawalItemList.action = 'update'
      this.showManpowerandServiceWithdrawal = true
    },
    saveManpowerandServiceWithdrawalChanges () {
      var is_valid = false
      if (this.lManpowerandServiceWithdrawalItemList.is_deb_informed === true || this.lManpowerandServiceWithdrawalItemList.deb_status === 'Informed') {
        if (!this.lManpowerandServiceWithdrawalItemList.is_deb_informed || !this.lManpowerandServiceWithdrawalItemList.deb_informed_dt || !this.lManpowerandServiceWithdrawalItemList.deb_status) {
          is_valid = false
          this.msg('Please enter all mandatory fields', 0)
        } else {
          is_valid = true
        }
      } else {
        is_valid = true
      }
      if (is_valid) {
        // this.lManpowerandServiceWithdrawalItemList.vendor_id = config.VENDOR_ID
        this.axios.post(config.API_URL + '/miDeboardManpowerandServiceWithdrawalUpdate/', this.lManpowerandServiceWithdrawalItemList)
        .then(response => {
          this.loadManpowerandServiceDetforWithdrawalItemList()
          this.msg('Saved Successfully', 1)
          this.showManpowerandServiceWithdrawal = false
        })
        .catch(err => {
          this.msg(err, 0)
        })
      }
    },
    loadOnbPlannerAssetRecoveryItemList() {
      // this method call is required to load project contract versions in the list. Otherwise approved project will be shown again for import.
      this.loadReviewVersionBasedonMIBaseId()
      var qry = {
        params: {
          mi_base_id: this.lDeboardReviewBase.mi_base_id,
          proj_contract_base_id: this.lDeboardReviewBase.proj_contract_base_id,
          showOnlyPendingItems: this.isShowOnlyPendingItems,
          vendor_id: config.VENDOR_ID
        }
      }
      this.onbPlannerRecoverAssetItemList = []
      this.axios.get(config.API_URL + '/getListOfOnbPlannerAssetRecoveryItemsBasedonMIBaseId/', qry)
      .then(response => {
        this.onbPlannerRecoverAssetItemList = response.data
      })
    },
    prepareOnbPlannerAssetRecoveryUpdate (curRec) {
      this.lOnbPlannerAssetRecovery = Object.assign({}, curRec)
      this.lOnbPlannerAssetRecovery.mi_asset_recovered_dt = this.lOnbPlannerAssetRecovery.mi_asset_recovered_dt ? handy.formatDBDate(this.lOnbPlannerAssetRecovery.mi_asset_recovered_dt) : null
      this.lOnbPlannerAssetRecovery.action = 'update'
      this.showOnbPlannerAssetRecovery = true
    },
    saveOnbPlannerAssetRecoveryChanges () {
      if (this.lOnbPlannerAssetRecovery.onb_planner_cat && this.lOnbPlannerAssetRecovery.onb_planner_sub_cat && this.lOnbPlannerAssetRecovery.mi_asset_rec_remarks) {
        this.lOnbPlannerAssetRecovery.vendor_id = config.VENDOR_ID
        this.axios.post(config.API_URL + '/miDeboardAssetRecoverOnbPlannerUpdate/', this.lOnbPlannerAssetRecovery)
        .then(response => {
          this.loadOnbPlannerAssetRecoveryItemList()
          this.msg('Saved Successfully', 1)
          this.showOnbPlannerAssetRecovery = false
        })
        .catch(err => {
          this.msg(err, 0)
        })
      } else {
        this.msg('Please enter all mandatory fields', 0)
      }
    },
    prepareDeboardingReviewView () {
      this.showDeboardingReviewView = true
    },
    loadDeboardValidationItemLists () {
      var qry = {
        params: {
          mi_base_id: this.lDeboardReviewBase.mi_base_id,
          proj_contract_base_id: this.lDeboardReviewBase.proj_contract_base_id,
          vendor_id: config.VENDOR_ID
        }
      }

      this.deboardPlannerValidationStatusList = []
      this.axios.get(config.API_URL + '/getDebOnbPlannerStatusList/', qry)
      .then(response => {
        this.deboardPlannerValidationStatusList = response.data
      })

      this.debAssetRecValidationStatusList = []
      this.axios.get(config.API_URL + '/getDebAssetRecoveryStatusList/', qry)
      .then(response => {
        this.debAssetRecValidationStatusList = response.data
      })

      this.debVendorWithdrawalValidationStatusList = []
      this.axios.get(config.API_URL + '/getDebVendorWithdrawalStatusList/', qry)
      .then(response => {
        this.debVendorWithdrawalValidationStatusList = response.data
      })
    },
    validateDeboardReview() {
      this.showDebPlannerValidationSummary = true
      this.isDebReviewValid = false
      this.loadDeboardValidationItemLists()
      setTimeout(() => {
        var debInvalidCnt = []
        debInvalidCnt = this.deboardPlannerValidationStatusList.filter(rec => rec.is_valid === "Invalid")
        var debAssetRecInvalidCnt = []
        debAssetRecInvalidCnt = this.debAssetRecValidationStatusList.filter(rec => rec.is_valid === "Invalid")
        var debVendorWithdrawalInvalidCnt = []
        debVendorWithdrawalInvalidCnt = this.debVendorWithdrawalValidationStatusList.filter(rec => rec.is_valid === "Invalid")

        if((debInvalidCnt && debInvalidCnt.length > 0) || (debAssetRecInvalidCnt && debAssetRecInvalidCnt.length > 0) || (debVendorWithdrawalInvalidCnt && debVendorWithdrawalInvalidCnt.length > 0)) {
          this.isDebReviewValid = false
        }
        else {
          this.isDebReviewValid = true
        }

      }, 500)
    },
    deboardReview () {
      this.validateDeboardReview()
      this.showDebPlannerValidationSummary = false
      setTimeout(() => {
        var qry = {
          params: {
            proj_contract_base_id: this.lDeboardReviewBase.proj_contract_base_id,
            vendor_id: config.VENDOR_ID
          }
        }
        if (!this.isDebReviewValid) {
          this.msg('Please complete all deboarding tasks before closing the review', 0)
        } else {
          // Whether the Selected contract version is currently in approved status or revised with new version.
          // Ask user to import the approved version in the Operation review if the selected version is changed to "Obsolute Approved" and any new approved version.
          this.axios.get(config.API_URL + '/getIsSelectedContractVersionStatusIsApproved/', qry)
          .then(resp => {
            if (resp.data.length > 0) {
              if (!confirm('Sure, you want to Close the Project Review ?')) {
                return
              }
              // up in db
              this.lDeboardReviewBase.vendor_id = config.VENDOR_ID
              this.lDeboardReviewBase.submitted_by = config.EMP_ID
              this.lDeboardReviewBase.status_on_deboard = this.lDeboardReviewBase.base_status
              this.axios.post(config.API_URL + '/miSalesReviewBase/Status-deboard', this.lDeboardReviewBase)
              .then(response => {
                // refresh stats
                this.loadDeboardingReviewDetails()
                this.loadDebaordReviewSummaryList()
              })
              .catch(err => {
                this.msg(err, 0)
              })
            } else {
              this.msg('Selected Contract Version is Obsolete Approved. Please Import Approved contract in Onboarding / Operation Review', 0)
            }
          })
          .catch(err => {
            this.msg(err, 0)
          })
        }
      }, 500)
    },
    reopenReview () {
      if (config.ROLE_NAME === 'Super Admin' && this.lDeboardReviewBase.base_status === 'Closed') {
        this.axios.post(config.API_URL + '/miReopenDeboardedReview/reopenReview', this.lDeboardReviewBase)
        .then(response => {
          this.msg('Review Reopened Successfully to status - ' + this.lDeboardReviewBase.status_on_deboard, 1)
          this.loadDeboardingReviewDetails()
          this.loadDebaordReviewSummaryList()
        })
        .catch(err => {
          this.msg(err, 0)
        })
      } else {
        this.msg('Review Reopen not possible. Review status should be Closed and user should be Super Admin', 0)
      }
    },
    prepareCreate () {
      this.lDeboardReviewMap = {
        comm_id: null,
        proj_id: null,
        mi_base_id: null,
        vendor_id: config.VENDOR_ID,
        action: 'create'
      }
      this.loadCommunityListHasReview()
      this.showAddDeboardProjectDialog = true
    },
    loadCommunityListHasReview () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.reviewCommList = []
      this.reviewProjList = []
      this.reviewBaseList = []
      this.axios.get(config.API_URL + '/getMiCommunityListHasReview/', qry)
      .then(response => {
        this.reviewCommList = response.data
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    loadProjectBasedOnCommIdHasReview (curRec) {
      var qry = {
        params: {
          comm_id: curRec.comm_id
        }
      }
      this.reviewProjList = []
      this.reviewBaseList = []
      this.axios.get(config.API_URL + '/getProjectListBasedOnCommId/', qry)
      .then(response => {
        this.reviewProjList = response.data
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    clearProjCombobox () {
      this.lDeboardReviewMap.proj_id = null
      this.lDeboardReviewMap.mi_base_id = null
    },
    closeAddDeboardProjectDialog () {
      this.showAddDeboardProjectDialog = false
    },
    loadActiveReviewForSelectedProject (curRec) {
      var qry = {
        params: {
          comm_id: curRec.comm_id,
          proj_id: curRec.proj_id
        }
      }
      this.reviewBaseList = []
      this.axios.get(config.API_URL + '/getMiActiveReviewForSelectedProject/', qry)
      .then(response => {
        this.reviewBaseList = response.data
        this.$forceUpdate()
      })
      .catch(err => {
        this.msg(err, 0)
      })
    },
    saveDeboardReviewMap (action) {
      var qry = {
        params: {
          comm_id: this.lDeboardReviewMap.comm_id,
          proj_id: this.lDeboardReviewMap.proj_id,
          mi_base_id: this.lDeboardReviewMap.mi_base_id,
          vendor_id: config.VENDOR_ID
        }
      }
      if (this.$refs.pDeboardForm.validate()) {
        if (!this.lDeboardReviewMap.comm_id || !this.lDeboardReviewMap.proj_id || !this.lDeboardReviewMap.mi_base_id) {
          this.msg('Please select all mandatory fields', 0)
        } else {
          this.axios.get(config.API_URL + '/getDeboardMapForCommProjMiBaseId/', qry)
          .then(response => {
            if (response.data.length > 0) {
              this.msg('Selected Project Review Already Exists in Deboarding Review, Please use the existing record', 0)
            } else {
              this.axios.post(config.API_URL + '/miDeboardReviewMapping/' + action, this.lDeboardReviewMap)
              .then(response => {
                if (response.data === 'Success') {
                  this.msg('Saved Successfully', 1)
                } else {
                  this.msg(response.data, 0)
                }
                this.loadDebaordReviewSummaryList()
                this.showAddDeboardProjectDialog = false
              })
              .catch(err => {
                this.msg(err, 0)
              })
            }
          })
        }
      }
    },
  }
}
</script>

<style lang="scss">
.importtabletd.v-data-table td{
  font-weight:normal;
  font-size:12px !important;
}
.importtableth.v-data-table th{
  font-weight:bold;
  font-size:12px !important;
}
.my-label-text-size .v-label {
  font-size: 14px !important;
}
</style>
